import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const ar: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "لم يُعثر على دليل أنماط الاقتباس",
    metaTitle: "أنماط الاقتباس التي تبدأ بـ {label}",
    metaDescription:
      "تصفّح {count} من أنماط Citation Style Language التي تبدأ بـ {label}. افتح أي نمط لعرض أمثلة اقتباس حقيقية ومولّد مجاني.",
    ogSubtitle: "{count} نمطًا مع أمثلة ومولّدات مخصصة.",
    ogKind: "دليل A–Z",
    schemaName: "أنماط الاقتباس التي تبدأ بـ {label}",
    schemaDescription:
      "دليل أبجدي يضم {count} من أنماط Citation Style Language التي تبدأ بـ {label}.",
    breadcrumbStyles: "أنماط الاقتباس",
    heading: "أنماط الاقتباس التي تبدأ بـ {label}",
    intro:
      "تصفّح جميع الأنماط البالغ عددها {count} في هذا الجزء من فهرس CSL. تتضمن كل صفحة أمثلة منسّقة للنمط نفسه ومولّد اقتباسات مجانيًا.",
    navLabel: "أنماط الاقتباس من A إلى Z",
    listHeading: "جميع الأنماط التي تبدأ بـ {label}",
  },
  nav: {
    tools: "الأدوات",
    guides: "الأدلة",
    styles: "كل الأنماط",
    bibliography: "قائمة مراجعي",
    search: "بحث",
    glossary: "المصطلحات",
    home: "الرئيسية",
    menu: "القائمة",
  },

  home: {
    title: "مُولِّد مراجع مجاني",
    subtitle: "مُحدَّث لعام 2026",
    intro:
      "الصق مُعرِّف DOI أو رابطًا أو مدخل BibTeX، أو ابحث عن كتاب، لتحصل على مرجع منسَّق بدقة وفق أنماط APA وMLA وشيكاغو وفانكوفر وهارفارد وآلاف الأنماط الأخرى. مجاني بالكامل، دون اشتراك مدفوع وبلا تسجيل.",
    browseAllStyles: "تصفَّح أنماط التوثيق كلها ({count}) ←",
    featuresHeading: "كل ما تحتاجه للتوثيق",
    featureStyles: "{count} نمط",
    featureStylesDetail: "APA وMLA وشيكاغو وغيرها",
    featureBibliographies: "قوائم مراجع متعددة",
    featureBibliographiesDetail: "نظِّمها حسب البحث",
    featureBookSearch: "البحث عن الكتب",
    featureBookSearchDetail: "بالعنوان أو اسم المؤلف",
    featureExport: "تصدير إلى أي برنامج",
    featureExportDetail: "BibTeX وWord وRIS وCSV",
    featureDarkMode: "الوضع الداكن",
    featureDarkModeDetail: "مريح للعين",
    featureNoSignup: "بلا تسجيل",
    featureNoSignupDetail: "مجاني دائمًا ودون اشتراك مدفوع",
    aboutHeading: "مُولِّد مراجع مجاني للطلبة والباحثين",
    aboutBody:
      "يدعم CitationEasy أكثر من عشرة آلاف نمط توثيق أكاديمي. سواء احتجت إلى APA في علم النفس أو MLA في الأدب أو شيكاغو في التاريخ أو فانكوفر في المجلات الطبية، فإن التنسيق مأخوذ من التعريف الرسمي للنمط نفسه، لا من تقدير تقريبي.",
    howItWorksHeading: "كيف يعمل",
    howItWorksStep1:
      "الصق مُعرِّف DOI أو رابطًا أو رقم ISBN أو معرّف PubMed أو arXiv أو مدخل BibTeX، ويمكنك أيضًا البحث عن كتاب بعنوانه.",
    howItWorksStep2: "اختر نمط التوثيق. اكتب للبحث بين الأنماط كلها ({count}).",
    howItWorksStep3:
      "انسخ المرجع الجاهز، أو احفظه في قائمة مراجع وصدِّره إلى Word أو BibTeX أو RIS.",
    privacyNote:
      "تُحفَظ قائمة مراجعك في متصفحك أنت. لا حساب، ولا يُرفَع أي شيء إلى خادم.",
  },

  hubs: {
    toolsTitle: "أدوات مجانية للكتابة والتوثيق",
    toolsIntro:
      "{count} أداة تعمل داخل المتصفح للكتابة والتوثيق: مُولِّدات لكل نوع من المصادر، وعدّادات للكلمات والحروف، وقياس سهولة القراءة، وأدوات تنسيق وتحويل. جميعها مجانية وفورية.",
    stylesTitle: "تصفَّح كل أنماط التوثيق",
    stylesIntro:
      "أنماط مشروع Citation Style Language كلها ({count})، مع بحث وتصفية حسب البلد والموضوع والتخصص الأكاديمي.",
    guidesTitle: "أدلة التوثيق والكتابة الأكاديمية",
    guidesIntro:
      "أدلة موسَّعة عن كيفية توثيق كل نوع من المصادر، وتقييم ما تجده، وتحسين كتابتك.",
    howToCiteTitle: "كيف توثِّق أي مصدر",
    howToCiteIntro:
      "صفحات خطوة بخطوة تجمع كل نوع مصدر شائع مع أنماط التوثيق الرئيسية، ولكل منها مثال حقيقي مُطبَّق.",
    faqTitle: "أسئلة شائعة عن التوثيق",
    faqIntro:
      "إجابات قصيرة ودقيقة عن الأسئلة التي تواجه الطلبة فعلًا عند التوثيق.",
    glossaryTitle: "مصطلحات التوثيق",
    glossaryIntro:
      "تعريفات واضحة للمصطلحات التي ترد في أدلة الأنماط وفي تعليمات الواجبات.",
    openHub: "افتح",
  },

  styleLanding: {
    metaTitle: "مُولِّد مراجع {style} مجاني",
    metaDescription:
      "أنشئ مراجع {style} مجانًا. الصق مُعرِّف DOI أو رابطًا أو ISBN أو BibTeX لتحصل على المرجع والإحالة داخل النص بتنسيق {style} الصحيح.",
    heading: "مُولِّد مراجع {style}",
    intro:
      "أنشئ مراجع {style} دقيقة للكتب ومقالات المجلات والمواقع بنقرة واحدة. مجاني وبلا تسجيل.",
    aboutHeading: "عن نمط {style}",
    whenToUseHeading: "متى يُستخدَم {style}",
    factsHeading: "{style} باختصار",
    factEdition: "الطبعة",
    factSystem: "نظام التوثيق",
    factInText: "الشكل داخل النص",
    factReferenceList: "اسم القائمة",
    factFields: "شائع في",
    systemAuthorDate: "المؤلف والتاريخ",
    systemNumbered: "الترقيم",
    systemFootnotes: "الحواشي السفلية",
    howToHeading: "كيف تستخدم مُولِّد {style} هذا",
    howToStep1:
      "الصق رابطًا أو DOI أو ISBN أو مدخل BibTeX في الحقل أعلاه، أو ابحث عن كتاب بعنوانه.",
    howToStep2: "نمط {style} مُحدَّد سلفًا في هذه الصفحة، فيمكنك الإنشاء مباشرة.",
    howToStep3: "انسخ الناتج إلى مستندك، أو احفظه وصدِّر القائمة كاملة لاحقًا.",
    relatedHeading: "مصادر إضافية عن {style}",
    englishOnlyNote:
      "تتوفر أدلة {style} المفصَّلة والأمثلة بحسب نوع المصدر باللغة الإنجليزية.",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "نمط التوثيق غير موجود",
    metaTitle: "مُولِّد مراجع {style} - تنسيق {style} المجاني",
    metaFormatAndFields: "{style} نمط {format} يُستخدَم في {fields}.",
    metaFormatOnly: "{style} نمط {format}.",
    metaFieldsOnly: "يُستخدَم {style} في {fields}.",
    metaPromiseNote:
      "طالِع حاشية سفلية حقيقية بنمط {style}، ثم أنشئ حاشيتك الخاصة مجانًا.",
    metaPromiseExamples:
      "طالِع أمثلة حقيقية على مراجع {style} لمقالة دورية وكتاب وموقع إلكتروني، ثم أنشئ مراجعك الخاصة مجانًا.",
    ogKindFormat: "نمط {format}",
    ogKindDefault: "نمط توثيق",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "و",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "نمط توثيق خاص بـ {name}، من مستودع Citation Style Language.",
    genericWhenUsed:
      "يُستخدَم عند النشر في المطبوعات التي تعتمد نمط {name}، أو عند الاقتباس منها.",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "الأنثروبولوجيا",
    disciplineAstronomy: "علم الفلك",
    disciplineBiology: "علم الأحياء",
    disciplineBotany: "علم النبات",
    disciplineChemistry: "الكيمياء",
    disciplineCommunications: "علوم الاتصال",
    disciplineEngineering: "الهندسة",
    disciplineGenericBase: "عام",
    disciplineGeography: "الجغرافيا",
    disciplineGeology: "الجيولوجيا",
    disciplineHistory: "التاريخ",
    disciplineHumanities: "العلوم الإنسانية",
    disciplineLaw: "القانون",
    disciplineLinguistics: "اللسانيات",
    disciplineLiterature: "الأدب",
    disciplineMath: "الرياضيات",
    disciplineMedicine: "الطب",
    disciplinePhilosophy: "الفلسفة",
    disciplinePhysics: "الفيزياء",
    disciplinePoliticalScience: "العلوم السياسية",
    disciplinePsychology: "علم النفس",
    disciplineScience: "العلوم",
    disciplineSocialScience: "العلوم الاجتماعية",
    disciplineSociology: "علم الاجتماع",
    disciplineTheology: "اللاهوت",
    disciplineZoology: "علم الحيوان",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "نمط قائم على المؤلف والتاريخ: تذكر الإحالات داخل النص اسم المؤلف والسنة، وتُرتَّب قائمة المراجع أبجديًا حسب اسم المؤلف",
    formatClassNumeric:
      "نمط رقمي: تُرقَّم المصادر حسب ترتيب ورودها الأول في النص، وتعتمد الإحالات داخل النص على هذه الأرقام",
    formatClassNote:
      "نمط قائم على الحواشي: تظهر الإحالات في حواشٍ سفلية أو ختامية بدلًا من أقواس داخل النص",
    formatClassLabel:
      "نمط ذو علامة مختصرة: تستخدم الإحالات داخل النص علامة موجزة تُبنى من اسم المؤلف والسنة",
    formatClassAuthor:
      "نمط يعتمد على المؤلف فقط: تذكر الإحالات داخل النص اسم المؤلف، وتُذكر التفاصيل الكاملة في قائمة المراجع",
    formatClassOther: "نمط {format}",
    breadcrumbStyles: "أنماط التوثيق",
    internationalLabel: "دولي",
    heading: "مُولِّد مراجع {style}",
    intro:
      "أنشئ مراجع {style} دقيقة للكتب والمقالات والمواقع الإلكترونية بنقرة واحدة.",
    examplesHeading: "أمثلة على مراجع {style}",
    examplesIntro: "المصادر الثلاثة نفسها بتنسيق {style}:",
    examplesIntroWithFormat: "المصادر الثلاثة نفسها بتنسيق {style} — {format}:",
    examplesNoteOnlyIntro:
      "{style} نمط قائم على الحواشي: لا توجد له قائمة مراجع، وكل إحالة هي حاشية سفلية. إليك مقالتنا الدورية النموذجية موثَّقة بنمط {style}:",
    labelJournalArticle: "مقالة دورية",
    labelBook: "كتاب",
    labelWebsite: "موقع إلكتروني",
    labelFootnote: "حاشية سفلية (مقالة دورية)",
    labelInText: "الإحالة داخل النص (للمقالة الدورية)",
    aboutHeading: "عن نمط {style}",
    whenToUseLabel: "متى يُستخدَم {style}:",
    commonInLabel: "شائع في:",
    subjectAreasLabel: "المجالات الموضوعية:",
    formattingRulesLabel: "قواعد التنسيق:",
    parentStylePrefix: "يتبع {style} تنسيق",
    parentStyleSuffix: "، وهو النمط الأصلي الذي يستند إليه.",
    howToHeading: "كيف تستخدم مُولِّد {style} هذا",
    howToBody:
      "الصق مُعرِّف DOI أو رابط مقالة إخبارية أو صفحة ويب، أو نص BibTeX خامًا، في الحقل أعلاه. يمكنك أيضًا البحث عن كتاب بعنوانه أو اسم مؤلفه وتوثيقه عبر رقم ISBN. اختر «{style}» من قائمة الأنماط المنسدلة (وهو محدَّد سلفًا في هذه الصفحة)، ثم اضغط «إنشاء المرجع». انسخ الناتج إلى قائمة مصادرك أو قائمة مراجعك. يمكنك تحرير المدخل الذي أُنشئ (كتصحيح عنوان أو إضافة تاريخ) قبل نسخه.",
    faqHeading: "أسئلة شائعة عن {style}",
    faqWhatIsQ: "ما هو نمط {style}؟",
    faqWhenQ: "متى ينبغي أن أستخدم {style}؟",
    faqInTextQ: "كيف تبدو الإحالة داخل النص في نمط {style}؟",
    faqInTextA:
      "{style} {format}. توثيق مقالتنا الدورية النموذجية داخل النص يبدو هكذا: {example}",
    faqReferenceQ: "كيف يبدو مدخل قائمة المراجع في نمط {style}؟",
    faqReferenceA: "مقالة دورية بتنسيق {style} تبدو هكذا: {example}",
    faqWhereQ: "أين يُستخدَم نمط {style} عادةً؟",
    faqWhereA: "يُستخدَم {style} {region}. {whenUsed}",
    faqRegionDefault: "على المستوى الدولي",
    faqGenerateQ: "كيف يمكنني إنشاء مرجع بنمط {style}؟",
    faqGenerateA:
      "استخدم المُولِّد المجاني في هذه الصفحة: الصق مُعرِّف DOI أو رابطًا (كرابط مقالة إخبارية مثلًا) أو نص BibTeX، أو ابحث عن كتاب بعنوانه أو اسم مؤلفه. اختر {style} بوصفه نمط التوثيق، واضغط «إنشاء» للحصول على مرجع منسَّق يمكنك نسخه إلى بحثك أو قائمة مراجعك.",
    footerSupports:
      "يدعم عددًا كبيرًا من أنماط التوثيق من شتى أنحاء العالم. يعتمد مُولِّدنا على أنماط Citation Style Language (CSL) من",
    footerRepoLink: "مستودع CSL الرسمي",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "أنشئ هذا الاستشهاد",
    generateBody:
      "الصق رابط URL أو DOI أو ISBN أو بيانات المصدر لتحصل على استشهاد جاهز بأسلوب {style} عند توثيق {source}.",
    generateCta: "افتح {tool} ←",
    guideHeading: "تعمّق أكثر",
    guideCta: "اقرأ الدليل الكامل: {guide}",
    howToCiteHeading: "كيفية توثيق {source} في كل أسلوب",
    howToCiteBody:
      "قواعد التنسيق والقوالب والأمثلة المحلولة للأساليب الأكثر طلبًا.",
    howToCiteMore: "جميع أنواع المصادر والأساليب ←",
    citeNowHeading: "ابدأ توثيق {source} بأسلوب {style} الآن",
    citeNowHowTo: "قواعد التنسيق والأمثلة المحلولة",
    citeNowTool: "أنشئه باستخدام {tool}",
    citeNowHub: "مولّد استشهادات {style}",
    hubSourcesHeading: "كيفية الاستشهاد بالمصادر الشائعة بأسلوب {style}",
    hubGuidesHeading: "أدلة {style}",
    hubCompareHeading: "قارن {style} بالأساليب الأخرى",
    moreInCollection: "المزيد في {collection}",
    seeAllInCollection: "عرض الكل في {collection}",
  },

  howToCitePage: {
    notFoundTitle: "غير موجود",
    title: "كيفية توثيق {source} بنمط {style} ({edition})",
    metaTitle: "كيفية توثيق {source} بنمط {style} [{edition}، تحديث 2026]",
    metaDescription:
      "تعلَّم كيفية توثيق {description} بتنسيق {style} ({edition}). أمثلة وقوالب وأدلة للإحالة داخل النص، كلها مجانية.",
    keywordCite: "توثيق {source} {style}",
    keywordCitation: "توثيق {source} بنمط {style}",
    keywordHowTo: "كيفية توثيق {source}",
    keywordExample: "مثال مرجع {style}",
    keywordReference: "مرجع {source} {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "الأعمال المُستشهَد بها",
    refListWorksCitedPage: "صفحة الأعمال المُستشهَد بها",
    refListBibliography: "قائمة المراجع",
    refListBibliographyLower: "قائمة المراجع",
    refListReferenceList: "قائمة المصادر",
    refListReferenceListLower: "قائمة المصادر",
    backLink: "→ كل أدلة التوثيق",
    lead: "تعلَّم كيفية توثيق {description} بتنسيق {style} ({edition}). يشمل هذا الدليل تنسيق قائمة المصادر، وأمثلة على الإحالة داخل النص، وأهم قواعد التنسيق.",
    referenceFormatHeading: "تنسيق {list} في {style}",
    referenceFormatIntro:
      "إليك التنسيق المعياري لنمط {style} لتوثيق {source} في {list}:",
    noTemplateNote: "اتبع القالب المعياري لنمط {style} لهذا النوع من المصادر.",
    workedHeading: "مثال على توثيق {source} بنمط {style}",
    workedIntro:
      "مرجع كامل بنمط {style} لتوثيق {source}، منسَّق وفق تعريف CSL الرسمي لنمط {style} — المحرك نفسه الذي يُشغِّل المُولِّد في هذا الموقع:",
    workedNoteOnlyIntro:
      "عند توثيق {source}، لا يُدرِج {style} مدخلًا ضمن {list} — بل تُذكر الإحالة في حاشية فقط. إليك هذه الحاشية، منسَّقة وفق تعريف CSL الرسمي لنمط {style}:",
    workedOscolaNote:
      "تتبع مخرجات OSCOLA المولَّدة في هذا الموقع نمط CSL للطبعة الرابعة، إذ لم يُنشر بعد نمط CSL للطبعة الخامسة في مستودع Citation Style Language. عدِّلها يدويًا: استبدل أي ibid بالاسم المختصر و(n X)، واستخدم معرّفات المحاكم الواردة في الطبعة الخامسة، وضع الصيغة المختصرة للقانون بين علامتي تنصيص مفردتين، وفضِّل رابطًا دائمًا أو DOI على تاريخ الاطلاع",
    workedCheckedIntro:
      "مرجع كامل بنمط {style} لتوثيق {source}، كُتب يدويًا ورُوجع وفق الإرشادات الرسمية لنمط {style} الخاصة بهذا المصدر:",
    workedCheckedNoteOnlyIntro:
      "عند توثيق {source}، لا يُدرِج {style} مدخلًا ضمن {list} — بل تُذكر الإحالة في حاشية فقط. إليك هذه الحاشية، مكتوبةً يدويًا ومُراجَعةً وفق الإرشادات الرسمية لنمط {style}:",
    workedInTextLabel: "الإحالة داخل النص المطابقة:",
    inTextHeading: "الإحالة داخل النص بنمط {style}",
    inTextIntro:
      "استخدم أحد هذين الشكلين عند الإحالة إلى هذا المصدر داخل بحثك:",
    inTextParenthetical: "بين قوسين",
    inTextNarrative: "سردي",
    rulesHeading: "أهم قواعد تنسيق {style}",
    stepsHeading: "دليل خطوة بخطوة",
    step1Label: "اجمع معلومات المصدر:",
    step1Body:
      "لتوثيق {source}، اجمع اسم المؤلف والعنوان وتاريخ النشر ورابط URL أو مُعرِّف DOI.",
    step2Label: "نسِّق المرجع:",
    step2Body: "رتِّب العناصر وفق قالب {style} ({edition}) الموضح أعلاه.",
    step3Label: "أنشئ الإحالة داخل النص:",
    step3Body:
      "أضف إحالة بين قوسين أو إحالة سردية في بحثك حيث تشير إلى هذا المصدر.",
    step4Label: "أضِفه إلى {list} الخاصة بك:",
    step4Body: "أدرج المرجع كاملًا ومنسَّقًا في نهاية بحثك.",
    step5Label: "تحقَّق من التنسيق مرة أخرى:",
    step5Body:
      "تأكَّد من مطابقة الخط المائل وعلامات الترقيم وحالة الأحرف والإزاحة المعلقة لمتطلبات {style}.",
    ctaHeading: "أنشئ هذا المرجع تلقائيًا",
    ctaBody:
      "تجاوَز التنسيق اليدوي. الصق مُعرِّف DOI أو رابطًا أو رقم ISBN في CitationEasy، واحصل على مرجع {style} منسَّق تنسيقًا كاملًا في ثوانٍ.",
    ctaButton: "وثِّق بنمط {style} الآن ←",
    otherStylesHeading: "توثيق {source} بأنماط أخرى",
    comboLink: "{source} بنمط {style}",
    otherSourcesHeading: "وثِّق مصادر أخرى بنمط {style}",
    resourcesHeading: "مزيد من المصادر",
    resourceGenerator: "مُولِّد مراجع مجاني ({count} نمط)",
    resourceTools: "أدوات الكتابة المجانية",
    resourceCompare: "قارِن أنماط التوثيق",
    resourceGuides: "كل أدلة التوثيق",
    resourceCheatSheets: "أوراق مرجعية سريعة (APA وMLA وشيكاغو)",
    resourceGlossary: "مسرد التوثيق (et al.، ibid.، DOI، الإزاحة المعلقة)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "جمع معلومات المصدر",
    schemaStep1Text:
      "اجمع كل المعلومات المطلوبة لتوثيق {source}، بما في ذلك المؤلف والعنوان والتاريخ ورابط URL أو مُعرِّف DOI.",
    schemaStep2Name: "التنسيق بنمط {style}",
    schemaStep2Text:
      "اتبع قواعد تنسيق {style} ({edition}) لترتيب عناصر المرجع بالترتيب الصحيح.",
    schemaStep3Name: "إنشاء الإحالة داخل النص",
    schemaStep3Text:
      "أضف إحالة داخل النص مطابقة في بحثك باستخدام تنسيق {style}.",
    schemaStep4Name: "الإضافة إلى قائمة المصادر",
    schemaStep4Text: "أدرج المرجع كاملًا في {list} في نهاية بحثك.",
    faqHowQ: "ما طريقة توثيق {source} بنمط {style}؟",
    faqHowA:
      "لتوثيق {source} بنمط {style} ({edition})، أدرِج المؤلف والعنوان والتاريخ وموضع المصدر. استخدم مُولِّد المراجع المجاني لدينا للحصول على تنسيق تلقائي.",
    faqFormatQ: "ما تنسيق {style} لتوثيق {source}؟",
    faqFormatA: "هذا هو تنسيق {style} لتوثيق {source}: {example}",
    faqFormatFallback:
      "يتطلب تنسيق {style} عناصر محددة مثل المؤلف والعنوان والتاريخ وموضع المصدر، مرتَّبة بترتيب معيّن.",
    faqInTextQ: "كيف تبدو الإحالة داخل النص عند توثيق {source} بنمط {style}؟",
    faqInTextA: "في {style}، الإحالة داخل النص للمثال أعلاه هي {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Arabic: bare indefinite nouns without tanwīn alif; every template keeps {source} genitive.
  howToCiteSources: {
    websiteName: "موقع إلكتروني",
    websiteTitle: "موقع إلكتروني",
    websitePhrase: "موقع إلكتروني",
    websiteNoun: "موقع إلكتروني",
    websiteDescription:
      "صفحات الويب والمقالات الإلكترونية وسائر المحتوى على الإنترنت",

    bookName: "كتاب",
    bookTitle: "كتاب",
    bookPhrase: "كتاب",
    bookNoun: "كتاب",
    bookDescription: "الكتب المطبوعة والإلكترونية",

    journalArticleName: "مقالة دورية",
    journalArticleTitle: "مقالة دورية",
    journalArticlePhrase: "مقالة دورية",
    journalArticleNoun: "مقالة دورية",
    journalArticleDescription: "مقالات الدوريات الأكاديمية والمحكَّمة",

    youtubeVideoName: "فيديو يوتيوب",
    youtubeVideoTitle: "فيديو يوتيوب",
    youtubeVideoPhrase: "فيديو يوتيوب",
    youtubeVideoNoun: "فيديو يوتيوب",
    youtubeVideoDescription: "مقاطع يوتيوب وسائر مقاطع الفيديو على الإنترنت",

    podcastName: "بودكاست",
    podcastTitle: "بودكاست",
    podcastPhrase: "بودكاست",
    podcastNoun: "بودكاست",
    podcastDescription: "حلقات البودكاست وسلاسله",

    newspaperArticleName: "مقالة صحفية",
    newspaperArticleTitle: "مقالة صحفية",
    newspaperArticlePhrase: "مقالة صحفية",
    newspaperArticleNoun: "مقالة صحفية",
    newspaperArticleDescription: "المقالات الصحفية المطبوعة والإلكترونية",

    magazineArticleName: "مقالة في مجلة",
    magazineArticleTitle: "مقالة في مجلة",
    magazineArticlePhrase: "مقالة في مجلة",
    magazineArticleNoun: "مقالة في مجلة",
    magazineArticleDescription: "مقالات المجلات المطبوعة والإلكترونية",

    blogPostName: "تدوينة",
    blogPostTitle: "تدوينة",
    blogPostPhrase: "تدوينة",
    blogPostNoun: "تدوينة",
    blogPostDescription: "التدوينات ومقالات الرأي المنشورة على الإنترنت",

    wikipediaName: "ويكيبيديا",
    wikipediaTitle: "ويكيبيديا",
    wikipediaPhrase: "ويكيبيديا",
    wikipediaNoun: "ويكيبيديا",
    wikipediaDescription: "مقالات ويكيبيديا ومداخل مواقع الويكي",

    pdfName: "ملف PDF",
    pdfTitle: "ملف PDF",
    pdfPhrase: "ملف PDF",
    pdfNoun: "ملف PDF",
    pdfDescription: "المستندات والتقارير بصيغة PDF",

    interviewName: "مقابلة",
    interviewTitle: "مقابلة",
    interviewPhrase: "مقابلة",
    interviewNoun: "مقابلة",
    interviewDescription: "المقابلات الشخصية والمنشورة والمذاعة",

    socialMediaName: "منشور على وسائل التواصل الاجتماعي",
    socialMediaTitle: "منشور على وسائل التواصل الاجتماعي",
    socialMediaPhrase: "منشور على وسائل التواصل الاجتماعي",
    socialMediaNoun: "منشور على وسائل التواصل الاجتماعي",
    socialMediaDescription:
      "التغريدات ومنشورات Instagram وFacebook ومقاطع TikTok",

    governmentDocumentName: "وثيقة حكومية",
    governmentDocumentTitle: "وثيقة حكومية",
    governmentDocumentPhrase: "وثيقة حكومية",
    governmentDocumentNoun: "وثيقة حكومية",
    governmentDocumentDescription:
      "التقارير الحكومية والتشريعات والوثائق الرسمية",

    dissertationName: "أطروحة أو رسالة جامعية",
    dissertationTitle: "أطروحة أو رسالة جامعية",
    dissertationPhrase: "أطروحة أو رسالة جامعية",
    dissertationNoun: "أطروحة أو رسالة جامعية",
    dissertationDescription: "أطروحات الدكتوراه ورسائل الماجستير",

    conferencePaperName: "ورقة مؤتمر",
    conferencePaperTitle: "ورقة مؤتمر",
    conferencePaperPhrase: "ورقة مؤتمر",
    conferencePaperNoun: "ورقة مؤتمر",
    conferencePaperDescription: "أعمال المؤتمرات والعروض المقدَّمة فيها",

    lectureNotesName: "محاضرة أو شرائح PowerPoint",
    lectureNotesTitle: "محاضرة أو شرائح PowerPoint",
    lectureNotesPhrase: "محاضرة أو شرائح PowerPoint",
    lectureNotesNoun: "محاضرة أو شرائح PowerPoint",
    lectureNotesDescription: "المحاضرات الصفية والشرائح والمواد الدراسية",

    webinarName: "ندوة عبر الإنترنت",
    webinarTitle: "ندوة عبر الإنترنت",
    webinarPhrase: "ندوة عبر الإنترنت",
    webinarNoun: "ندوة عبر الإنترنت",
    webinarDescription: "الندوات عبر الإنترنت، المباشرة منها والمسجَّلة",

    onlineCourseName: "دورة عبر الإنترنت",
    onlineCourseTitle: "دورة عبر الإنترنت",
    onlineCoursePhrase: "دورة عبر الإنترنت",
    onlineCourseNoun: "دورة عبر الإنترنت",
    onlineCourseDescription:
      "الدورات عبر الإنترنت ودورات MOOC على منصات مثل Coursera وedX وUdemy وFutureLearn",

    presentationSlidesName: "عرض PowerPoint",
    presentationSlidesTitle: "عرض PowerPoint",
    presentationSlidesPhrase: "عرض PowerPoint",
    presentationSlidesNoun: "عرض PowerPoint",
    presentationSlidesDescription: "عروض PowerPoint وشرائح العروض التقديمية",

    imageName: "صورة أو صورة فوتوغرافية",
    imageTitle: "صورة أو صورة فوتوغرافية",
    imagePhrase: "صورة أو صورة فوتوغرافية",
    imageNoun: "صورة أو صورة فوتوغرافية",
    imageDescription:
      "الصور الفوتوغرافية والأعمال الفنية والرسوم البيانية والصور المنشورة على الإنترنت",

    movieName: "فيلم",
    movieTitle: "فيلم",
    moviePhrase: "فيلم",
    movieNoun: "فيلم",
    movieDescription: "فيلم سينمائي",

    documentaryName: "فيلم وثائقي",
    documentaryTitle: "فيلم وثائقي",
    documentaryPhrase: "فيلم وثائقي",
    documentaryNoun: "فيلم وثائقي",
    documentaryDescription: "الأفلام الوثائقية وغيرها من الأفلام غير الروائية",

    tvShowName: "برنامج تلفزيوني",
    tvShowTitle: "برنامج تلفزيوني",
    tvShowPhrase: "برنامج تلفزيوني",
    tvShowNoun: "برنامج تلفزيوني",
    tvShowDescription: "برنامج تلفزيوني أو مسلسل",

    songName: "أغنية أو مقطوعة موسيقية",
    songTitle: "أغنية أو مقطوعة موسيقية",
    songPhrase: "أغنية أو مقطوعة موسيقية",
    songNoun: "أغنية أو مقطوعة موسيقية",
    songDescription: "أغنية أو تسجيل موسيقي",

    poemName: "قصيدة",
    poemTitle: "قصيدة",
    poemPhrase: "قصيدة",
    poemNoun: "قصيدة",
    poemDescription:
      "القصائد والأبيات الشعرية والشعر المنشور في المختارات أو الدواوين",

    courtCaseName: "قضية محكمة",
    courtCaseTitle: "قضية محكمة",
    courtCasePhrase: "قضية محكمة",
    courtCaseNoun: "قضية محكمة",
    courtCaseDescription: "قضية محكمة أو حكم قضائي",

    patentName: "براءة اختراع",
    patentTitle: "براءة اختراع",
    patentPhrase: "براءة اختراع",
    patentNoun: "براءة اختراع",
    patentDescription: "براءة اختراع أو طلب تسجيل ملكية فكرية",

    encyclopediaName: "مدخل في موسوعة",
    encyclopediaTitle: "مدخل في موسوعة",
    encyclopediaPhrase: "مدخل في موسوعة",
    encyclopediaNoun: "مدخل في موسوعة",
    encyclopediaDescription: "مقالة أو مدخل في موسوعة",

    dictionaryName: "مدخل في معجم",
    dictionaryTitle: "مدخل في معجم",
    dictionaryPhrase: "مدخل في معجم",
    dictionaryNoun: "مدخل في معجم",
    dictionaryDescription: "تعريف أو مدخل في معجم",

    datasetName: "مجموعة بيانات",
    datasetTitle: "مجموعة بيانات",
    datasetPhrase: "مجموعة بيانات",
    datasetNoun: "مجموعة بيانات",
    datasetDescription: "مجموعة بيانات أو قاعدة بيانات",

    softwareName: "برنامج أو تطبيق",
    softwareTitle: "برنامج أو تطبيق",
    softwarePhrase: "برنامج أو تطبيق",
    softwareNoun: "برنامج أو تطبيق",
    softwareDescription: "برمجية أو تطبيق أو برنامج حاسوبي",

    videoGameName: "لعبة فيديو",
    videoGameTitle: "لعبة فيديو",
    videoGamePhrase: "لعبة فيديو",
    videoGameNoun: "لعبة فيديو",
    videoGameDescription: "ألعاب الفيديو وبرمجيات الألعاب التفاعلية",

    pressReleaseName: "بيان صحفي",
    pressReleaseTitle: "بيان صحفي",
    pressReleasePhrase: "بيان صحفي",
    pressReleaseNoun: "بيان صحفي",
    pressReleaseDescription: "بيان صحفي أو إعلان إخباري",

    reportName: "تقرير",
    reportTitle: "تقرير",
    reportPhrase: "تقرير",
    reportNoun: "تقرير",
    reportDescription: "تقرير أو ورقة بيضاء",

    preprintName: "نسخة أولية",
    preprintTitle: "نسخة أولية",
    preprintPhrase: "نسخة أولية",
    preprintNoun: "نسخة أولية",
    preprintDescription:
      "الأوراق المنشورة على arXiv وbioRxiv وغيرهما من خوادم النسخ الأولية",

    bookChapterName: "فصل من كتاب",
    bookChapterTitle: "فصل من كتاب",
    bookChapterPhrase: "فصل من كتاب",
    bookChapterNoun: "فصل من كتاب",
    bookChapterDescription: "الفصول والمقالات المنشورة في الكتب المحرَّرة",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription: "ChatGPT وغيره من أدوات الذكاء الاصطناعي التوليدي",

    bibleName: "الكتاب المقدس",
    bibleTitle: "الكتاب المقدس",
    biblePhrase: "الكتاب المقدس",
    bibleNoun: "الكتاب المقدس",
    bibleDescription: "الكتاب المقدس وسائر الكتب والنصوص المقدسة",

    tedTalkName: "محاضرة TED",
    tedTalkTitle: "محاضرة TED",
    tedTalkPhrase: "محاضرة TED",
    tedTalkNoun: "محاضرة TED",
    tedTalkDescription: "محاضرات TED وغيرها من محاضرات المؤتمرات المسجَّلة",

    emailName: "رسالة بريد إلكتروني",
    emailTitle: "رسالة بريد إلكتروني",
    emailPhrase: "رسالة بريد إلكتروني",
    emailNoun: "رسالة بريد إلكتروني",
    emailDescription: "رسائل البريد الإلكتروني والخطابات والمراسلات الشخصية",

    redditName: "منشور على Reddit أو منتدى",
    redditTitle: "منشور على Reddit أو منتدى",
    redditPhrase: "منشور على Reddit",
    redditNoun: "منشور على Reddit",
    redditDescription:
      "سلاسل النقاش على Reddit وجلسات AMA ومنشورات المنتديات ولوحات النقاش على الإنترنت",

    tweetName: "منشور على X (تويتر)",
    tweetTitle: "منشور على X (تويتر)",
    tweetPhrase: "منشور على X",
    tweetNoun: "منشور على X",
    tweetDescription: "التغريدات والمنشورات على منصة X (تويتر سابقًا)",

    mapName: "خريطة",
    mapTitle: "خريطة",
    mapPhrase: "خريطة",
    mapNoun: "خريطة",
    mapDescription:
      "الخرائط المطبوعة والأطالس والخرائط التفاعلية مثل خرائط Google",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription:
      "محادثات Claude وغيرها من مخرجات الذكاء الاصطناعي من Anthropic",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription: "محادثات Google Gemini ومخرجاته من الذكاء الاصطناعي",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription:
      "محادثات Microsoft Copilot وإجاباته المولَّدة بالذكاء الاصطناعي",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription:
      "إجابات Perplexity ومحادثاته والمصادر التي يستشهد بها",

    aiImageName: "صورة مولَّدة بالذكاء الاصطناعي",
    aiImageTitle: "صورة مولَّدة بالذكاء الاصطناعي",
    aiImagePhrase: "صورة مولَّدة بالذكاء الاصطناعي",
    aiImageNoun: "صورة مولَّدة بالذكاء الاصطناعي",
    aiImageDescription:
      "الصور المُنشأة باستخدام DALL·E وMidjourney وGemini وغيرها من أدوات الذكاء الاصطناعي",

    tiktokName: "فيديو على TikTok",
    tiktokTitle: "فيديو على TikTok",
    tiktokPhrase: "فيديو على TikTok",
    tiktokNoun: "فيديو على TikTok",
    tiktokDescription: "مقاطع TikTok ومنشورات صنّاع المحتوى",

    instagramName: "منشور على Instagram",
    instagramTitle: "منشور على Instagram",
    instagramPhrase: "منشور على Instagram",
    instagramNoun: "منشور على Instagram",
    instagramDescription: "منشورات Instagram ومقاطع ريلز والقصص",

    statuteName: "قانون أو تشريع",
    statuteTitle: "قانون أو تشريع",
    statutePhrase: "قانون أو تشريع",
    statuteNoun: "قانون أو تشريع",
    statuteDescription:
      "القوانين الصادرة عن السلطة التشريعية والتشريعات والقوانين المقنَّنة",

    isoStandardName: "معيار ISO",
    isoStandardTitle: "معيار ISO",
    isoStandardPhrase: "معيار ISO",
    isoStandardNoun: "معيار ISO",
    isoStandardDescription:
      "معايير ISO وIEC وغيرها من المعايير التقنية المنشورة",

    quranName: "القرآن الكريم",
    quranTitle: "القرآن الكريم",
    quranPhrase: "القرآن الكريم",
    quranNoun: "القرآن الكريم",
    quranDescription: "القرآن الكريم بنصه العربي أو مترجمًا",

    ebookNoPageNumbersName: "كتاب إلكتروني بلا أرقام صفحات",
    ebookNoPageNumbersTitle: "كتاب إلكتروني بلا أرقام صفحات",
    ebookNoPageNumbersPhrase: "كتاب إلكتروني بلا أرقام صفحات",
    ebookNoPageNumbersNoun: "كتاب إلكتروني بلا أرقام صفحات",
    ebookNoPageNumbersDescription:
      "كتب Kindle وEPUB والكتب الإلكترونية على الإنترنت التي لا تحمل أرقام صفحات ثابتة",

    speechName: "خطاب",
    speechTitle: "خطاب",
    speechPhrase: "خطاب",
    speechNoun: "خطاب",
    speechDescription: "الخطب والكلمات والمواعظ، المباشرة منها أو المسجَّلة",

    letterName: "رسالة",
    letterTitle: "رسالة",
    letterPhrase: "رسالة",
    letterNoun: "رسالة",
    letterDescription:
      "الرسائل المنشورة والرسائل المحفوظة في الأرشيف والرسائل المفتوحة",

    secondarySourceName: "مصدر ثانوي",
    secondarySourceTitle: "مصدر ثانوي",
    secondarySourcePhrase: "مصدر ثانوي",
    secondarySourceNoun: "مصدر ثانوي",
    secondarySourceDescription: "مصدر وجدتَه مُقتبَسًا أو مُستشهَدًا به في عمل آخر",
  },

  // ---------------------------------------------------------------------------
  // NOT YET TRANSLATED. These five sections were copied verbatim from `en.ts` so
  // this file still satisfies `Dictionary`; the page types they cover
  // (`taxonomy`, `compare`, `convert`) are deliberately absent from
  // TRANSLATED_PAGE_TYPES, so nothing publishes them in this language yet. The
  // translation pass replaces the strings and only then adds the types.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "غير موجود",
    fieldMetaTitle: "أنماط التوثيق في {field} - أفضل صيغ التوثيق لعام 2026",
    fieldMetaDescription:
      "اكتشف أكثر أنماط التوثيق استخدامًا في {field}. اعثر على صيغة التوثيق المناسبة لبحثك أو رسالتك أو مقالك المُقدَّم في مجال {fieldLower}.",
    fieldOgTitle: "أنماط التوثيق في {field}",
    fieldOgSubtitle: "الأكثر شيوعًا: {styles}.",
    fieldOgKind: "حسب المجال الأكاديمي",
    fieldKeywordStyle: "نمط توثيق {field}",
    fieldKeywordReferencing: "توثيق مراجع {field}",
    fieldKeywordBest: "أفضل نمط توثيق لـ{fieldLower}",
    fieldKeywordBibliography: "صيغة قائمة مراجع {fieldLower}",
    fieldKeywordDiscipline: "أنماط التوثيق حسب التخصص",
    fieldBackLink: "← كل أنماط التوثيق",
    fieldHeading: "أنماط التوثيق في {field}",
    fieldRecommendedHeading: "أنماط التوثيق الموصى بها",
    fieldRecommendedIntro:
      "أنماط التوثيق التالية شائعة الاستخدام في أبحاث {field} ومجلاتها ومقرراتها الدراسية. اختر نمطًا لمعرفة المزيد وبدء إنشاء المراجع.",
    fieldStyleFallback: "نمط توثيق يُستخدَم في {field} والتخصصات ذات الصلة.",
    fieldRelatedHeading: "مجالات ذات صلة",
    fieldRelatedIntro:
      "استكشف أنماط التوثيق المستخدمة في التخصصات الأكاديمية ذات الصلة:",
    fieldCtaHeading: "استكشف كل أنماط التوثيق",
    fieldCtaBody:
      "يدعم CitationEasy {count} نمط توثيق تغطي كل التخصصات الأكاديمية. تصفَّح المجموعة كاملةً لتجد الصيغة الدقيقة التي تحتاجها.",
    fieldCtaButton: "تصفَّح كل الأنماط ←",
    fieldFaqWhichQ: "ما نمط التوثيق المستخدَم في {field}؟",
    fieldFaqWhichA:
      "يعتمد نمط التوثيق المستخدَم في {field} على متطلبات المجلة أو المؤسسة أو المُدرِّس تحديدًا. من الأنماط الشائعة {styles}. تحقَّق دائمًا من إرشادات واجبك أو المجلة المستهدفة لمعرفة الصيغة المطلوبة.",
    fieldFaqSameQ: "هل تستخدم كل مجلات {field} النمط نفسه؟",
    fieldFaqSameA:
      "لا، لا تستخدم كل مجلات {field} نمط التوثيق نفسه. فرغم شيوع بعض الأنماط أكثر من غيرها في هذا المجال، قد يكون لكل مجلة متطلبات تنسيق خاصة بها. تحقَّق دائمًا من إرشادات النشر الخاصة بالمجلة قبل إعداد مخطوطتك.",
    fieldFaqChooseQ: "كيف أختار نمط توثيق لبحثي في {field}؟",
    fieldFaqChooseA:
      "لاختيار نمط توثيق لبحثك في {field}، تحقَّق أولًا مما إذا كان مُدرِّسك أو المجلة المستهدفة يحدد نمطًا مطلوبًا. إن لم يكن كذلك، استخدم أحد الأنماط الموصى بها لـ{field} المذكورة أعلاه. يدعم CitationEasy أكثر من {count} نمط، ويمكنه إنشاء المراجع بأي منها مجانًا.",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "الدولة غير موجودة",
    countryMetaTitle: "أنماط التوثيق في {country} - APA وMLA وغيرها",
    countryMetaDescription:
      "تصفَّح أنماط التوثيق المستخدمة في {country}. مُولِّد مراجع مجاني لصيغ {country}.",
    countryOgTitle: "أنماط التوثيق المستخدمة في {country}",
    countryOgKind: "حسب الدولة",
    countryHeading: "أنماط التوثيق في {country}",
    countryIntroOne:
      "{count} نمط توثيق شائع الاستخدام في {country} أو مرتبط بها. اختره لفتح مُولِّد مخصَّص.",
    countryIntroMany:
      "{count} نمط توثيق شائع الاستخدام في {country} أو مرتبط بها. اختر أحدها لفتح مُولِّد مخصَّص.",
    countryBrowserTitle: "أنماط التوثيق في {country}",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "لم يتم العثور على النوع",
    typeMetaTitle: "أنماط توثيق {type} - مُولِّد مجاني",
    typeMetaDescription:
      "أنماط توثيق لمجال {typeLower}. تشمل APA وMLA وVancouver وغيرها. مُولِّد مراجع مجاني.",
    typeOgTitle: "أنماط توثيق {type}",
    typeOgKind: "حسب الموضوع",
    typeHeading: "أنماط توثيق {type}",
    typeIntroOne:
      "{count} نمط توثيق لـ{typeLower}. اختره لفتح مُولِّد مخصَّص مع أسئلة شائعة.",
    typeIntroMany:
      "{count} نمط توثيق لـ{typeLower}. اختر أحدها لفتح مُولِّد مخصَّص مع أسئلة شائعة.",
    typeBrowserTitle: "أنماط توثيق {type}",

    // ---- Shared chrome ----
    breadcrumbStyles: "أنماط التوثيق",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "أنماط التوثيق",
    breadcrumbByCountry: "حسب الدولة",
    breadcrumbByDiscipline: "حسب التخصص",
    allStylesLink: "← كل أنماط التوثيق",
    internationalLabel: "دولي",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "علم النفس",
    education: "التربية",
    sociology: "علم الاجتماع",
    anthropology: "الأنثروبولوجيا",
    politicalScience: "العلوم السياسية",
    economics: "الاقتصاد",
    business: "الأعمال والإدارة",
    literature: "الأدب واللغات",
    history: "التاريخ",
    philosophy: "الفلسفة",
    law: "القانون والدراسات القانونية",
    medicine: "الطب والعلوم السريرية",
    nursing: "التمريض والقبالة",
    publicHealth: "الصحة العامة وعلم الأوبئة",
    pharmacy: "الصيدلة",
    biology: "علم الأحياء والعلوم الحيوية",
    chemistry: "الكيمياء",
    physics: "الفيزياء",
    engineering: "الهندسة",
    computerScience: "علوم الحاسوب",
    mathematics: "الرياضيات والإحصاء",
    environmentalScience: "العلوم البيئية",
    earthScience: "علوم الأرض والجيولوجيا",
    artHistory: "تاريخ الفن والفنون البصرية",
    music: "الموسيقى وعلم الموسيقى",
    theology: "اللاهوت والدراسات الدينية",
    socialWork: "الخدمة الاجتماعية",
    linguistics: "اللسانيات",
    architecture: "العمارة والتخطيط العمراني",
    filmMedia: "دراسات السينما والإعلام",
    journalism: "الصحافة والاتصال",
    criminology: "علم الجريمة والعدالة الجنائية",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "أنماط توثيق شائعة الاستخدام في علم النفس والعلوم السلوكية والبحث المعرفي.",
    education: "أنماط توثيق لأبحاث التربية وعلم التدريس والمناهج الدراسية.",
    sociology: "أنماط توثيق تُستخدَم في البحث الاجتماعي والنظرية الاجتماعية.",
    anthropology: "أنماط توثيق للبحث الأنثروبولوجي والإثنوغرافي.",
    politicalScience:
      "أنماط توثيق للعلوم السياسية والحكومة وبحوث السياسات العامة.",
    economics: "أنماط توثيق تُستخدَم في أبحاث الاقتصاد والاقتصاد القياسي.",
    business: "أنماط توثيق لأبحاث الأعمال والإدارة والتسويق والتمويل.",
    literature: "أنماط توثيق للدراسات الأدبية واللسانيات وأبحاث اللغة.",
    history: "أنماط توثيق للبحث التاريخي وكتابة التاريخ والدراسات الأرشيفية.",
    philosophy: "أنماط توثيق للكتابة الفلسفية وأبحاث الأخلاقيات.",
    law: "أنماط توثيق قانونية للمستندات القضائية والمجلات القانونية والدراسات القانونية.",
    medicine: "أنماط توثيق للبحث الطبي والدراسات السريرية والرعاية الصحية.",
    nursing: "أنماط توثيق لأبحاث التمريض والممارسة الصحية.",
    publicHealth: "أنماط توثيق لأبحاث الصحة العامة والدراسات الوبائية.",
    pharmacy: "أنماط توثيق للأبحاث الصيدلانية والدوائية.",
    biology: "أنماط توثيق للبحث البيولوجي وعلم البيئة وعلم الوراثة.",
    chemistry: "أنماط توثيق لأبحاث الكيمياء والكيمياء الحيوية وعلوم المواد.",
    physics:
      "أنماط توثيق لأبحاث الفيزياء والفيزياء الفلكية والفيزياء التطبيقية.",
    engineering: "أنماط توثيق لأبحاث الهندسة والتكنولوجيا التطبيقية.",
    computerScience:
      "أنماط توثيق لأبحاث علوم الحاسوب والذكاء الاصطناعي وهندسة البرمجيات.",
    mathematics: "أنماط توثيق لأبحاث الرياضيات والرياضيات التطبيقية والإحصاء.",
    environmentalScience: "أنماط توثيق للبحث البيئي ودراسات الاستدامة.",
    earthScience: "أنماط توثيق لأبحاث الجيولوجيا والجيوفيزياء وعلوم الأرض.",
    artHistory: "أنماط توثيق لتاريخ الفن والثقافة البصرية ودراسات المتاحف.",
    music: "أنماط توثيق لأبحاث الموسيقى ونظريتها ودراسات الأداء.",
    theology: "أنماط توثيق للدراسات اللاهوتية والدينية.",
    socialWork: "أنماط توثيق لأبحاث الخدمة الاجتماعية وممارستها.",
    linguistics: "أنماط توثيق للسانيات وعلم الأصوات وعلوم اللغة.",
    architecture: "أنماط توثيق لأبحاث العمارة والتصميم الحضري والتخطيط.",
    filmMedia: "أنماط توثيق لدراسات السينما والتلفزيون والإعلام والاتصال.",
    journalism: "أنماط توثيق لأبحاث الصحافة والدراسات الإعلامية والاتصال.",
    criminology: "أنماط توثيق لأبحاث علم الجريمة والعدالة الجنائية.",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "الولايات المتحدة",
    unitedKingdom: "المملكة المتحدة",
    australia: "أستراليا",
    canada: "كندا",
    newZealand: "نيوزيلندا",
    ireland: "أيرلندا",
    southAfrica: "جنوب أفريقيا",
    germany: "ألمانيا",
    france: "فرنسا",
    spain: "إسبانيا",
    italy: "إيطاليا",
    netherlands: "هولندا",
    belgium: "بلجيكا",
    switzerland: "سويسرا",
    austria: "النمسا",
    portugal: "البرتغال",
    luxembourg: "لوكسمبورغ",
    sweden: "السويد",
    norway: "النرويج",
    denmark: "الدانمارك",
    finland: "فنلندا",
    iceland: "آيسلندا",
    poland: "بولندا",
    czechRepublic: "التشيك",
    hungary: "المجر",
    romania: "رومانيا",
    russia: "روسيا",
    ukraine: "أوكرانيا",
    greece: "اليونان",
    turkey: "تركيا",
    croatia: "كرواتيا",
    slovenia: "سلوفينيا",
    slovakia: "سلوفاكيا",
    serbia: "صربيا",
    bulgaria: "بلغاريا",
    lithuania: "ليتوانيا",
    latvia: "لاتفيا",
    estonia: "إستونيا",
    japan: "اليابان",
    china: "الصين",
    southKorea: "كوريا الجنوبية",
    india: "الهند",
    singapore: "سنغافورة",
    hongKong: "هونغ كونغ",
    taiwan: "تايوان",
    malaysia: "ماليزيا",
    indonesia: "إندونيسيا",
    thailand: "تايلاند",
    vietnam: "فيتنام",
    philippines: "الفلبين",
    pakistan: "باكستان",
    bangladesh: "بنغلاديش",
    sriLanka: "سريلانكا",
    israel: "إسرائيل",
    saudiArabia: "المملكة العربية السعودية",
    unitedArabEmirates: "الإمارات العربية المتحدة",
    brazil: "البرازيل",
    mexico: "المكسيك",
    argentina: "الأرجنتين",
    chile: "تشيلي",
    colombia: "كولومبيا",
    peru: "بيرو",
    venezuela: "فنزويلا",
    egypt: "مصر",
    nigeria: "نيجيريا",
    kenya: "كينيا",
    morocco: "المغرب",
    international: "دولي",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "الطب",
    nursing: "التمريض",
    publicHealth: "الصحة العامة",
    pharmacy: "الصيدلة",
    dentistry: "طب الأسنان",
    veterinary: "الطب البيطري",
    psychology: "علم النفس",
    sociology: "علم الاجتماع",
    anthropology: "الأنثروبولوجيا",
    politicalScience: "العلوم السياسية",
    economics: "الاقتصاد",
    education: "التربية",
    socialWork: "الخدمة الاجتماعية",
    biology: "علم الأحياء",
    chemistry: "الكيمياء",
    physics: "الفيزياء",
    environmentalScience: "العلوم البيئية",
    earthScience: "علوم الأرض والجيولوجيا",
    agriculture: "الزراعة",
    ecology: "علم البيئة",
    engineering: "الهندسة",
    computerScience: "علوم الحاسوب",
    mathematics: "الرياضيات",
    statistics: "الإحصاء",
    history: "التاريخ",
    literature: "الأدب",
    philosophy: "الفلسفة",
    linguistics: "اللسانيات",
    artHistory: "تاريخ الفن",
    music: "الموسيقى",
    filmMedia: "السينما والإعلام",
    archaeology: "علم الآثار",
    law: "القانون",
    business: "الأعمال",
    architecture: "العمارة",
    religion: "الأديان واللاهوت",
    geography: "الجغرافيا",
    general: "عام / متعدد التخصصات",
    other: "أخرى",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "قائمة المصادر",
    listWorksCited: "الأعمال المُستشهَد بها",
    listReferences: "المراجع",
    listBibliography: "قائمة المراجع",
    listTableOfAuthorities: "جدول السلطات القانونية",
    listReferencesCited: "المراجع المُستشهَد بها",
    listLowerReferenceList: "قائمة المصادر",
    listLowerWorksCited: "الأعمال المُستشهَد بها",
    listLowerReferences: "المراجع",
    listLowerBibliography: "قائمة المراجع",
    listLowerTableOfAuthorities: "جدول السلطات القانونية",
    listLowerReferencesCited: "المراجع المُستشهَد بها",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(المؤلف، السنة)",
    inTextAuthorPage: "(المؤلف الصفحة)",
    inTextAuthorYear: "(المؤلف السنة)",
    inTextSuperscriptOrBracketed: "أرقام مرفوعة أو بين قوسين (1)",
    inTextBracketedNumbers: "أرقام بين قوسين معقوفين [1]",
    inTextSuperscriptNumbers: "أرقام مرفوعة¹",
    inTextSuperscriptOrAuthorYear: "أرقام مرفوعة أو (المؤلف السنة)",
    inTextKeyBased: "مراجع مبنية على مفاتيح الاستشهاد",
    inTextSuperscriptOrAuthorCommaYear: "أرقام مرفوعة أو (المؤلف، السنة)",
    inTextFootnotesCaseLegislation: "حواشٍ سفلية بإحالات إلى القضايا والتشريعات",
    inTextFootnotesSignals: "حواشٍ سفلية باختصارات إشارات الاستشهاد",
    inTextFootnotesPinpoint: "حواشٍ سفلية بإحالات محدَّدة الموضع",
    inTextParenNumbers: "أرقام بين قوسين (1)",
    inTextItalicNumbers: "أرقام مائلة (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "الطبعة الرابعة",
    edition5th: "الطبعة الخامسة",
    edition7th: "الطبعة السابعة",
    edition8th: "الطبعة الثامنة",
    edition9th: "الطبعة التاسعة",
    edition11th: "الطبعة الحادية عشرة",
    edition18th: "الطبعة الثامنة عشرة",
    edition22nd: "الطبعة الثانية والعشرون",
    editionCiteThemRight11th: "Cite Them Right الطبعة الحادية عشرة",
    editionIcmjeStandard: "معيار ICMJE",
    editionStandard: "قياسي",
    editionCurrent: "الحالية",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "علم الصوتيات",
    fieldAnthropology: "الأنثروبولوجيا",
    fieldAppliedPhysics: "الفيزياء التطبيقية",
    fieldArchaeology: "علم الآثار",
    fieldArts: "الفنون",
    fieldAstrophysics: "الفيزياء الفلكية",
    fieldAustralianLaw: "القانون الأسترالي",
    fieldBiochemistry: "الكيمياء الحيوية",
    fieldBiology: "علم الأحياء",
    fieldBiomedicalSciences: "العلوم الطبية الحيوية",
    fieldBiotechnology: "التقنية الحيوية",
    fieldBusiness: "الأعمال",
    fieldCellBiology: "علم الأحياء الخلوي",
    fieldChemicalEngineering: "الهندسة الكيميائية",
    fieldChemistry: "الكيمياء",
    fieldClinicalResearch: "البحوث السريرية",
    fieldComputerScience: "علوم الحاسوب",
    fieldCondensedMatter: "فيزياء المادة المكثفة",
    fieldCourtDocuments: "الوثائق القضائية",
    fieldCriminology: "علم الجريمة",
    fieldCulturalStudies: "الدراسات الثقافية",
    fieldDemography: "الديموغرافيا",
    fieldEcology: "علم البيئة",
    fieldEducation: "التربية",
    fieldElectronics: "الإلكترونيات",
    fieldEngineering: "الهندسة",
    fieldEnvironmentalScience: "العلوم البيئية",
    fieldEpidemiology: "علم الأوبئة",
    fieldEthnography: "الإثنوغرافيا",
    fieldGenetics: "علم الوراثة",
    fieldGeology: "الجيولوجيا",
    fieldGlobalHealth: "الصحة العالمية",
    fieldHealthSciences: "العلوم الصحية",
    fieldHistory: "التاريخ",
    fieldHumanities: "العلوم الإنسانية",
    fieldInformationSystems: "نظم المعلومات",
    fieldInformationTechnology: "تقنية المعلومات",
    fieldInternationalRelations: "العلاقات الدولية",
    fieldJurisprudence: "الفقه القانوني",
    fieldLanguages: "اللغات",
    fieldLaw: "القانون",
    fieldLawReview: "المجلات القانونية",
    fieldLegalStudies: "الدراسات القانونية",
    fieldLifeSciences: "علوم الحياة",
    fieldLiterature: "الأدب",
    fieldMaterialsScience: "علم المواد",
    fieldMathematics: "الرياضيات",
    fieldMedicine: "الطب",
    fieldMolecularBiology: "علم الأحياء الجزيئي",
    fieldMultidisciplinary: "متعدد التخصصات",
    fieldMultidisciplinaryScience: "العلوم متعددة التخصصات",
    fieldNaturalSciences: "العلوم الطبيعية",
    fieldNursing: "التمريض",
    fieldPharmacy: "الصيدلة",
    fieldPhysics: "الفيزياء",
    fieldPoliticalScience: "العلوم السياسية",
    fieldPsychology: "علم النفس",
    fieldPublicHealth: "الصحة العامة",
    fieldPublicPolicy: "السياسة العامة",
    fieldPublishing: "النشر",
    fieldScience: "العلوم",
    fieldSciences: "مجالات العلوم",
    fieldSocialSciences: "العلوم الاجتماعية",
    fieldSocialWork: "الخدمة الاجتماعية",
    fieldSociology: "علم الاجتماع",
    fieldSoftwareEngineering: "هندسة البرمجيات",
    fieldTheology: "اللاهوت",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "نمط التوثيق الأكثر استخدامًا في العلوم الاجتماعية",
    mla: "نمط التوثيق المعياري في العلوم الإنسانية",
    chicago:
      "دليل الأسلوب الأكثر ثقة لدى المؤلفين والمحررين والناشرين في أمريكا",
    harvard: "نمط التوثيق الأكثر شيوعًا في الجامعات البريطانية والأسترالية",
    vancouver: "نمط التوثيق المعياري في المجلات الطبية والطبية الحيوية",
    ieee: "نمط التوثيق المعتمَد في الهندسة وعلوم الحاسوب",
    ama: "معيار التوثيق في المجلات الطبية الأمريكية",
    turabian: "النسخة المبسَّطة من نمط Chicago، المُعَدَّة للطلاب",
    cse: "نمط التوثيق المفضَّل في العلوم الطبيعية والفيزيائية",
    bibtex: "صيغة قوائم المراجع لمستخدمي LaTeX والتنضيد الأكاديمي",
    nature: "نمط التوثيق الذي تعتمده أبرز مجلة متعددة التخصصات في العالم",
    acs: "معيار التوثيق في الكيمياء والعلوم الكيميائية",
    oscola:
      "نمط التوثيق القانوني المعياري في كليات الحقوق والمجلات القانونية البريطانية",
    bluebook:
      "نظام التوثيق القانوني المرجعي للمحاكم الأمريكية والمجلات القانونية",
    aglc: "نمط التوثيق القانوني المعياري في كليات الحقوق والمحاكم الأسترالية",
    asa: "نمط التوثيق المعياري في علم الاجتماع والبحث الاجتماعي",
    apsa: "نمط التوثيق المعتمَد في أبحاث العلوم السياسية ومجلاتها",
    aaa: "نمط التوثيق المعياري في البحث الأنثروبولوجي",
    nlm: "معيار التوثيق المعتمَد لدى PubMed والمكتبة الوطنية الأمريكية للطب",
    acm: "نمط التوثيق المعتمَد في مؤتمرات ACM وأبحاث الحوسبة",
    aps: "نمط التوثيق المعتمَد في Physical Review ومجلات APS",
    aip: "نمط التوثيق المعتمَد في AIP والمجلات الفيزيائية",
    cell: "نمط التوثيق المعتمَد لدى Cell Press وأبرز مجلات الأحياء",
    science: "نمط التوثيق المعتمَد في مجلة Science ومجلات AAAS",
    plos: "نمط التوثيق المعتمَد في مجلات PLOS مفتوحة الوصول",
    bmj: "نمط التوثيق المعتمَد في BMJ وأبرز المجلات الطبية البريطانية",
    lancet: "نمط التوثيق المعتمَد في مجلات The Lancet الطبية",
    jama: "نمط التوثيق المعتمَد في JAMA ومجلات JAMA Network",
    elsevierHarvard: "نسخة من نمط Harvard معتمَدة في مجلات Elsevier",
    springer: "نمط التوثيق المعتمَد في مجلات وكتب Springer Nature",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "غير موجود",
    metaTitle: "{a} مقابل {b} - أبرز الفروق (تحديث 2026)",
    metaDescription:
      "قارِن بين نمطي التوثيق {a} و{b} جنبًا إلى جنب. تعرَّف على أهم الفروق في التنسيق والإحالات داخل النص وقوائم المراجع لاختيار النمط المناسب لبحثك.",
    ogTitle: "{a} مقابل {b}",
    ogSubtitle:
      "الشكل داخل النص، وصياغة مدخلات المراجع، وقواعد حالة الأحرف، والتخصصات التي يتطلب كل نمط استخدامها.",
    ogKind: "مقارنة بين الأنماط",
    keywordVs: "{a} مقابل {b}",
    keywordVersus: "{a} في مقابل {b}",
    keywordDifference: "الفرق بين {a} و{b}",
    keywordOr: "{a} أم {b}",
    keywordComparison: "مقارنة أنماط التوثيق",
    breadcrumbCompare: "قارِن الأنماط",
    breadcrumbCurrent: "{a} مقابل {b}",
    backLink: "← العودة إلى أداة المقارنة",
    heading: "{a} مقابل {b}: أبرز الفروق",
    intro:
      "{a} و{b} من أكثر أنماط التوثيق استخدامًا في الأوساط الأكاديمية، لكنهما يختلفان في جوانب مهمة. {introA} {introB} فهم هذه الفروق يساعدك على اختيار الصيغة المناسبة لبحثك.",
    styleIntro: "{style} ({fullName}) {tagline}.",
    styleIntroFallback:
      "{style} نمط توثيق شائع يُستخدَم في العديد من التخصصات الأكاديمية.",
    tableHeading: "مقارنة جنبًا إلى جنب",
    tableFeature: "الخاصية",
    tableCitationSystem: "نظام التوثيق",
    tableInText: "الشكل داخل النص",
    tableReferenceList: "اسم قائمة المراجع",
    tableEdition: "الطبعة",
    tableCommonFields: "المجالات الشائعة",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "المؤلف والتاريخ",
    systemNumbered: "الترقيم",
    systemFootnotes: "الحواشي السفلية",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "نظام المؤلف والتاريخ بين قوسين",
    describeNumbered: "نظام مرقَّم",
    describeFootnotes: "نظام قائم على الحواشي السفلية",
    whenToUseHeading: "متى تستخدم {style}",
    whenToUseBody:
      "يعتمد {style} ({fullName}) نظام توثيق {system} بإحالات داخل النص على شكل {inText}، و{list} في نهاية البحث. يُستخدَم غالبًا في {fields}{more}.",
    whenToUseMoreFields: "، وفي مجالات ذات صلة",
    whenToUseFallback:
      "{style} نمط توثيق معترف به على نطاق واسع. تحقَّق من إرشادات واجبك أو المجلة المستهدفة للتأكد مما إذا كان {style} هو الصيغة المطلوبة.",
    ctaHeading: "شاهد الفرق عمليًا",
    ctaBodyBefore: "جرِّب",
    ctaBodyLink: "أداة المقارنة التفاعلية",
    ctaBodyAfter: "لمقارنة مراجع {a} و{b} جنبًا إلى جنب باستخدام مصادرك الخاصة.",
    ctaCiteIn: "وثِّق بنمط {style} ←",
    faqDifferenceQ: "ما الفرق بين {a} و{b}؟",
    faqDifferenceA:
      "يختلف {a} عن {b} في شكل الإحالة داخل النص، وبنية قائمة المراجع، والتخصصات الأكاديمية التي تستخدم كلًا منهما. {detail}",
    faqDifferenceDetail:
      "يستخدم {a} إحالات داخل النص على شكل {inTextA} مع {listA}، بينما يستخدم {b} {inTextB} مع {listB}.",
    faqDifferenceDetailFallback:
      "لكل نمط قواعده الخاصة في تنسيق الاستشهادات وتنظيم قوائم المراجع والتعامل مع أنواع المصادر المختلفة.",
    faqBetterQ: "أيهما أفضل، {a} أم {b}؟",
    faqBetterA:
      "لا يُعَد {a} ولا {b} أفضل من الآخر بطبيعته. يعتمد الاختيار الصحيح على تخصصك الأكاديمي، أو متطلبات مُدرِّسك، أو المجلة التي تقدِّم إليها بحثك. تحقَّق من إرشادات واجبك أو الجهة المستهدفة للنشر لتحديد النمط الواجب استخدامه.",
    faqSwitchQ: "هل يمكنني التبديل بين {a} و{b}؟",
    faqSwitchA:
      "نعم، يمكنك التبديل بين {a} و{b} باستخدام مُولِّد المراجع المجاني في CitationEasy. اختر النمط المطلوب وستُعاد صياغة مراجعك تلقائيًا. مع ذلك، يُفضَّل استخدام نمط واحد فقط في البحث الواحد، ما لم يوجِّهك مُدرِّسك بخلاف ذلك.",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "أداة التحويل غير موجودة",
    metaTitle: "{title} - مجاني وفوري",
    ogTitle: "{title}",
    ogKind: "أداة تحويل",
    breadcrumbConverters: "أدوات التحويل",
    breadcrumbLabel: "مسار التنقل",
    whenHeading: "متى تحتاج إلى هذا",
    relatedHeading: "أدوات تحويل ذات صلة",
    allConverters: "كل أدوات التحويل",
    formatConverterTool: "محوِّل صيغ التوثيق",
    faqHowQ: "كيف أحوِّل {input} إلى {output}؟",
    faqHowA: "{intro} كل شيء مجاني، بلا حساب وبلا حد أقصى لعدد التحويلات.",
    faqPrivacyQ: "هل تُرفَع بياناتي إلى أي مكان؟",
    faqPrivacyIdentifier:
      "يُبحَث عن كل {input} في خدمة البيانات الوصفية العامة المعنية (Crossref لمعرِّفات DOI، وPubMed لمعرِّفات PMID، وسجلات المكتبات لأرقام ISBN)، ولا يُرسَل سوى المُعرِّف نفسه — لا تُرسَل مستنداتك مطلقًا. النتائج المُنسَّقة مِلكٌ لك، يمكنك نسخها أو تنزيلها؛ ولا يُحفَظ شيء.",
    faqPrivacyLocal:
      "لا — يُحلَّل {input} الذي تلصقه أو ترفعه بالكامل داخل متصفحك. {detail}",
    faqPrivacyDetailStyle:
      "لا يُرسَل إلى مُنسِّقنا سوى حقول المرجع المُستخرَجة (المؤلف والعنوان والسنة) لإنشاء الاستشهادات؛ أما ملفك نفسه فلا يغادر جهازك مطلقًا.",
    faqPrivacyDetailOffline:
      "يتم التحويل بالكامل دون اتصال داخل الصفحة — لا يُرسَل شيء إلى أي خادم.",
    faqUsefulQ: "متى يكون تحويل {input} إلى {output} مفيدًا؟",
    faqOtherQ: "هل يمكنني التحويل إلى أنماط وصيغ أخرى أيضًا؟",
    faqOtherA:
      "نعم. يُنسِّق مُولِّد CitationEasy أي مصدر بـ {count} نمط توثيق، وتُصدَّر قائمة المراجع بصيغ Word وRTF وBibTeX وRIS وCSL-JSON، ويسرد مركز أدوات التحويل كل أزواج التحويل المباشرة. إن كنت بحاجة إلى إعادة صياغة نص مُنسَّق مسبقًا من نمط إلى آخر، استخدم بدلًا من ذلك أداة محوِّل صيغ التوثيق.",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "محوِّل استشهادات من DOI إلى APA",
    doiToApaMetaDescription:
      "الصق مُعرِّفات DOI (واحدًا في كل سطر) واحصل فورًا على مراجع APA 7 مستخرَجة من بيانات Crossref الرسمية للناشر. مجاني، بلا حساب.",
    doiToApaIntro:
      "يشير مُعرِّف DOI أصلًا إلى البيانات الوصفية الموثوقة لدى الناشر، فلا داعي لكتابة مرجع APA يدويًا. الصق مُعرِّفًا واحدًا في كل سطر، ويتحوَّل كل منها إلى مرجع APA 7 كامل — بأسماء مؤلفين مقلوبة، وعنوان بأحرف الجملة، واسم دورية مائل، ورابط https://doi.org/ الذي يشترطه APA.",
    doiToApaUseCase:
      "لحظة معتادة: يطلب أستاذك قائمة مراجع بنمط APA، وكل ما لديك كومة من مُعرِّفات DOI جمَّعتها أثناء القراءة. الصق الكومة، وانسخ القائمة.",
    doiToMlaTitle: "محوِّل استشهادات من DOI إلى MLA",
    doiToMlaMetaDescription:
      "حوِّل مُعرِّفات DOI تلقائيًا إلى مدخلات قائمة الأعمال المُستشهَد بها بنمط MLA 9 باستخدام بيانات Crossref. الصق مُعرِّفًا واحدًا في كل سطر — مجاني، بلا تثبيت.",
    doiToMlaIntro:
      "يتعامل MLA 9 مع مقالة الدورية باعتبارها سلسلة من العناصر المتداخلة — عنوان المقالة بين علامتي تنصيص، واسم الدورية مائل، والمجلد، والعدد، والسنة، والصفحات — وهو أمر دقيق يصعب تجميعه يدويًا. يملأ البحث عبر DOI كل عنصر من سجل الناشر، فيخرج مدخل قائمة الأعمال المُستشهَد بها صحيحًا من أول مرة.",
    doiToMlaUseCase:
      "مفيد حين يشترط مقرر في العلوم الإنسانية نمط MLA بينما مصادرك من قواعد بيانات علمية لا تمنحك سوى مُعرِّفات DOI.",
    doiToBibtexTitle: "محوِّل DOI إلى BibTeX",
    doiToBibtexMetaDescription:
      "حوِّل مُعرِّفات DOI إلى مدخلات BibTeX لـLaTeX وOverleaf. الصق مُعرِّفًا واحدًا في كل سطر، ونزِّل ملف .bib جاهزًا — مجاني وبلا حدود.",
    doiToBibtexIntro:
      "يحتاج كل بحث بصيغة LaTeX في النهاية إلى ملف .bib خاص به. الصق مُعرِّفات DOI سطرًا سطرًا واحصل على مدخلات @article نظيفة بمفاتيح استشهاد مُولَّدة تلقائيًا، جاهزة لـOverleaf أو natbib أو biblatex — دون نسخ الحقول يدويًا من صفحات الناشر.",
    doiToBibtexUseCase:
      "السيناريو المعتاد: يرسل لك محكِّم ثلاث أوراق بحثية للاستشهاد بها، ولديك مُعرِّفات DOI الخاصة بها، وموعدك النهائي الليلة. الصق، ونزِّل، ثم استخدم \\cite مباشرةً.",
    doiToRisTitle: "محوِّل DOI إلى RIS",
    doiToRisMetaDescription:
      "حوِّل مُعرِّفات DOI إلى ملف RIS يستورده Zotero وMendeley وEndNote مباشرةً. الصق مُعرِّفات DOI سطرًا سطرًا — مجاني، بلا تسجيل.",
    doiToRisIntro:
      "RIS هو صيغة التبادل التي يستوردها كل برنامج لإدارة المراجع. الصق مُعرِّفات DOI ونزِّل ملف .ris تأتي حقوله TY/AU/TI/T2 مباشرةً من Crossref — ثم استخدم أمر «ملف ← استيراد» في Zotero أو Mendeley أو EndNote لتصل المدخلات مُهيكَلة بالكامل.",
    doiToRisUseCase:
      "مثالي لنقل قائمة مُعرِّفات DOI التي جمعتها يدويًا إلى برنامج إدارة مراجع حقيقي دون إعادة كتابة اسم مؤلف واحد.",
    isbnToApaTitle: "محوِّل استشهادات من ISBN إلى APA",
    isbnToApaMetaDescription:
      "حوِّل أرقام ISBN تلقائيًا إلى مراجع كتب بنمط APA 7. الصق رقمًا واحدًا في كل سطر وانسخ القائمة المُنسَّقة — مجاني، بلا حساب.",
    isbnToApaIntro:
      "رقم ISBN الموجود في صفحة حقوق النشر بالكتاب هو كل ما تحتاجه لمرجعه بنمط APA. يُبحَث عن كل رقم ISBN في بيانات المكتبات ويُنسَّق بنمط APA 7 — المؤلف والسنة والعنوان المائل والناشر — إضافةً إلى معلومات الطبعة إن وُجدت في السجل.",
    isbnToApaUseCase:
      "أسرع طريقة للاستشهاد بكومة من كتب المكتبة الورقية: افتح صفحة حقوق النشر في كل كتاب، اكتب أرقام ISBN، والصق القائمة هنا.",
    isbnToMlaTitle: "محوِّل استشهادات من ISBN إلى MLA",
    isbnToMlaMetaDescription:
      "حوِّل أرقام ISBN إلى مدخلات قائمة الأعمال المُستشهَد بها بنمط MLA 9 بلصقة واحدة. بحث مجاني عن ISBN بمخرجات مُنسَّقة — بلا تسجيل.",
    isbnToMlaIntro:
      "مدخلات الكتب في MLA 9 قصيرة — المؤلف، والعنوان المائل، والناشر، والسنة — لكن ضبط قلب اسم المؤلف وعلامات الترقيم لا يزال يوقع الكثيرين في الخطأ. يستخرج البحث عبر ISBN سجل الكتاب الفعلي في الفهرس، وينسِّقه وفق قالب العناصر الأساسية في دليل MLA.",
    isbnToMlaUseCase:
      "مثالي لأبحاث الأدب: استشهد بكل رواية ودراسة نقدية على مكتبك بمجرد كتابة الأرقام الموجودة على الغلاف الخلفي.",
    isbnToBibtexTitle: "محوِّل ISBN إلى BibTeX",
    isbnToBibtexMetaDescription:
      "حوِّل أرقام ISBN إلى مدخلات @book بصيغة BibTeX لـLaTeX. الصق رقمًا واحدًا في كل سطر، ونزِّل ملف .bib — مجاني وفوري.",
    isbnToBibtexIntro:
      "تُعَد الكتب الزاوية الأكثر إزعاجًا في BibTeX — لا يوجد DOI للبحث عنه، ونادرًا ما تقدِّم صفحات الناشرين تصديرًا بصيغة .bib. يستخرج هذا المحوِّل بيانات كل رقم ISBN من سجلات المكتبات، ويُنشئ مدخلات @book بحقول المؤلف والعنوان والناشر والسنة مكتملة.",
    isbnToBibtexUseCase:
      "لكاتبي الأطروحات: تستشهد فصول المنهجية بمُعرِّفات DOI للدوريات، بينما يستشهد الفصل النظري باثني عشر كتابًا. هذه الأداة تتولى تلك الكتب الاثني عشر.",
    pmidToApaTitle: "محوِّل استشهادات من PMID إلى APA",
    pmidToApaMetaDescription:
      "حوِّل مُعرِّفات PubMed تلقائيًا إلى مراجع بنمط APA 7. الصق مُعرِّفات PMID سطرًا سطرًا واحصل على قائمة مراجع مُنسَّقة — مجاني.",
    pmidToApaIntro:
      "لكل سجل في PubMed مُعرِّف PMID، وتشترط برامج علم النفس والتمريض غالبًا نمط APA. الصق مُعرِّفات PMID سطرًا سطرًا، ويتحوَّل كل منها عبر بيانات PubMed نفسها إلى مرجع دورية كامل بنمط APA 7، مع رابط DOI إن وُجد في السجل.",
    pmidToApaUseCase:
      "صُمِّم لواجبات الممارسة القائمة على الأدلة: تنتهي استراتيجية بحثك بقائمة من مُعرِّفات PMID، ويحتاج بحثك إليها بنمط APA.",
    pmidToRisTitle: "محوِّل PMID إلى RIS",
    pmidToRisMetaDescription:
      "حوِّل مُعرِّفات PubMed إلى ملف RIS لـZotero أو Mendeley أو EndNote. الصق مُعرِّفات PMID سطرًا سطرًا، ونزِّل ملف .ris — مجاني.",
    pmidToRisIntro:
      "تعتمد مسارات عمل المراجعات المنهجية على ملفات RIS. الصق مُعرِّفات PMID من بحثك في PubMed ونزِّل ملف .ris جاهزًا لأداة الفرز أو برنامج إدارة المراجع — كل سجل مُهيكَل من بيانات PubMed الرسمية لا من نص مُستخرَج بالقص واللصق.",
    pmidToRisUseCase:
      "مفيد في منتصف المراجعة، حين يرسل لك زميل رسالة يقول فيها «أضِف هذه الدراسات الخمس أيضًا» ومعها مُعرِّفات PMID فقط، بينما مكتبتك في EndNote.",
    arxivToBibtexTitle: "محوِّل arXiv إلى BibTeX",
    arxivToBibtexMetaDescription:
      "حوِّل مُعرِّفات arXiv إلى مدخلات BibTeX لأبحاث LaTeX. الصق مُعرِّفات مثل 2301.12345، واحدًا في كل سطر، ونزِّل ملف .bib — مجاني.",
    arxivToBibtexIntro:
      "يُستشهَد بالأبحاث الأولية باستمرار في المجالات سريعة التطور، ومُعرِّفات arXiv (مثل 2301.12345) هي وسيلة تداولها. الصق المُعرِّفات واحصل على مدخلات BibTeX بمؤلفي البحث الأولي وعنوانه وسنته ورابط arXiv — جاهزة لملف .bib الخاص ببحثك.",
    arxivToBibtexUseCase:
      "لكتَّاب التعلم الآلي والفيزياء الذين يشكِّل arXiv نسبة 80% من قسم الأعمال ذات الصلة لديهم: اجمع المُعرِّفات أثناء القراءة، وحوِّلها دفعة واحدة عند الكتابة.",
    bibtexToApaTitle: "محوِّل BibTeX إلى APA",
    bibtexToApaMetaDescription:
      "الصق ملف .bib أو ارفعه واحصل على قائمة مراجع بنمط APA 7. يدعم الملفات متعددة المدخلات — مجاني، ويتم التحليل في متصفحك.",
    bibtexToApaIntro:
      "أحيانًا يغادر البحث بيئة LaTeX — تطلب دورية تقديمًا بصيغة Word، أو تطلب لجنة قائمة المراجع كنص عادي. الصق BibTeX (أو ارفع ملف .bib)، ويُحلَّل كل مدخل في متصفحك، ثم يُنسَّق كقائمة مراجع بنمط APA 7 يمكنك إدراجها في أي مستند.",
    bibtexToApaUseCase:
      "الحل الخاص بطلبات المنح: قائمة منشوراتك محفوظة في ملف .bib، ونموذج الجهة المانحة يطلب مراجع بنمط APA في مربع نصي.",
    bibtexToMlaTitle: "محوِّل BibTeX إلى MLA",
    bibtexToMlaMetaDescription:
      "حوِّل BibTeX إلى مدخلات قائمة الأعمال المُستشهَد بها بنمط MLA 9. الصق ملف .bib أو ارفعه وانسخ القائمة المُنسَّقة — مجاني، بلا حساب.",
    bibtexToMlaIntro:
      "يخزِّن BibTeX الحقول الخام؛ أما MLA فيحدِّد بدقة كيفية ترتيبها. يحلِّل هذا المحوِّل مدخلات .bib محليًا، ويعرض كل واحد وفق قالب MLA 9 — بأسماء مؤلفين مقلوبة، وعناوين مقالات بين علامتي تنصيص، وأسماء أوعية مائلة، وعلامات ترقيم صحيحة بين العناصر.",
    bibtexToMlaUseCase:
      "للباحثين متعددي التخصصات: مراجعك محفوظة بصيغة BibTeX من عمل سابق بـLaTeX، لكن الدورية الإنسانية التي تتقدَّم إليها تطلب MLA.",
    bibtexToRisTitle: "محوِّل BibTeX إلى RIS",
    bibtexToRisMetaDescription:
      "حوِّل ملف .bib إلى RIS لـZotero أو Mendeley أو EndNote. الصق BibTeX أو ارفعه، ونزِّل ملف .ris — مجاني وبلا اتصال.",
    bibtexToRisIntro:
      "الانتقال من أدوات LaTeX إلى برنامج إدارة مراجع يعني ترجمة مدخلات @article/@book في BibTeX إلى وسوم TY/AU/TI في RIS. يتم التحويل بالكامل داخل متصفحك — بما في ذلك تخطيط الحقول — ويمنحك ملف .ris يستورده أي برنامج.",
    bibtexToRisUseCase:
      "الدافع المعتاد: مؤلف مشارك جديد يعمل على Zotero، ومراجعكم المشتركة ملف .bib في المستودع، وعلى أحدكم أن يسدَّ هذه الفجوة.",
    bibtexToCslJsonTitle: "محوِّل BibTeX إلى CSL-JSON",
    bibtexToCslJsonMetaDescription:
      "حوِّل BibTeX إلى CSL-JSON لـPandoc وQuarto. الصق ملف .bib أو ارفعه، ونزِّل references.json — مجاني، داخل المتصفح.",
    bibtexToCslJsonIntro:
      "يستشهد Pandoc وQuarto من CSL-JSON مباشرةً، وتحويل ملف .bib الحالي يزيل جزءًا متحرِّكًا من عملية البناء. تُحلَّل المدخلات في متصفحك وتخرج كمصفوفة CSL-JSON نظيفة — بالشكل الذي يتوقعه --bibliography=references.json تحديدًا.",
    bibtexToCslJsonUseCase:
      "للأكاديميين الذين يعملون بصيغة Markdown وينقلون مشروع LaTeX قديمًا إلى Quarto: انقل قائمة مراجعك دون تحرير JSON يدويًا.",
    bibtexToWordTitle: "محوِّل BibTeX إلى Word",
    bibtexToWordMetaDescription:
      "حوِّل ملف .bib إلى مستند Word بقائمة مراجع بنمط APA وإزاحة معلَّقة. مجاني — يتم التحليل في متصفحك.",
    bibtexToWordIntro:
      "حين يحتاج ملف .bib إلى أن يصبح مستندًا لا صيغة بيانات أخرى، يحلِّل هذا المحوِّل ملف BibTeX محليًا، وينسِّق كل مدخل بنمط APA 7، ويحمِّل ملف Word تكون فيه قائمة المراجع مُرتَّبة أبجديًا وبإزاحة معلَّقة جاهزة.",
    bibtexToWordUseCase:
      "خطوة في نهاية المسار: قبِلت الدورية البحث لكنها تطلب قائمة المراجع النهائية كملف Word قابل للتحرير، ومصدرك الأساسي هو BibTeX.",
    risToApaTitle: "محوِّل RIS إلى APA",
    risToApaMetaDescription:
      "الصق تصدير RIS أو ارفعه واحصل على قائمة مراجع بنمط APA 7. يعمل مع Zotero وMendeley وEndNote وملفات تصدير قواعد البيانات — مجاني.",
    risToApaIntro:
      "ينتج زر «تصدير» في كل قاعدة بيانات ملف RIS؛ والواجبات تطلب APA. الصق التصدير (أو ارفع ملف .ris) ويُحلَّل كل سجل TY/AU/TI في متصفحك ويُعرَض كمرجع بنمط APA 7 — دون الحاجة إلى تثبيت أي برنامج لإدارة المراجع.",
    risToApaUseCase:
      "الطريق المختصر لقواعد بيانات المكتبات: صدِّر نتائج بحثك بصيغة RIS، وحوِّلها هنا، وتجنَّب إعداد Zotero من أجل بحث واحد فقط.",
    risToMlaTitle: "محوِّل RIS إلى MLA",
    risToMlaMetaDescription:
      "حوِّل تصدير RIS من قواعد البيانات أو برامج إدارة المراجع إلى مدخلات قائمة الأعمال المُستشهَد بها بنمط MLA 9. الصق أو ارفع — مجاني، بلا تسجيل.",
    risToMlaIntro:
      "تُصدِّر JSTOR وProQuest وEBSCO جميعها بصيغة RIS، وتطلب أقسام اللغة الإنجليزية جميعًا نمط MLA. تسدُّ هذه الصفحة تلك الفجوة — تُحلَّل السجلات محليًا وتُعرَض وفق قالب عناصر MLA 9 الأساسية، جاهزة للصقها في صفحة قائمة أعمالك المُستشهَد بها.",
    risToMlaUseCase:
      "مُعَدَّة لليلة التي تسبق تسليم المقال: عشرة مصادر مُصدَّرة من JSTOR بصيغة citations.ris، ولا رغبة في تنسيقها يدويًا.",
    risToBibtexTitle: "محوِّل RIS إلى BibTeX",
    risToBibtexMetaDescription:
      "حوِّل RIS إلى BibTeX لـLaTeX وOverleaf. الصق تصدير .ris أو ارفعه، ونزِّل ملف .bib نظيفًا — مجاني، داخل المتصفح.",
    risToBibtexIntro:
      "في اتجاه LaTeX: تتحدَّث برامج إدارة المراجع وقواعد البيانات لغة RIS، بينما يحتاج بناء بحثك إلى .bib. تُحوَّل السجلات بالكامل داخل متصفحك — بتخطيط الأنواع من وسوم TY، وتوليد مفاتيح الاستشهاد — إلى ملف يقبله Overleaf كما هو.",
    risToBibtexUseCase:
      "شائع في التعاون البحثي: يُصدِّر مستخدم Zotero ملف RIS، ويمرِّره مستخدم LaTeX عبر هذه الصفحة، ويحتفظ كل منهما بأدواته.",
    risToCslJsonTitle: "محوِّل RIS إلى CSL-JSON",
    risToCslJsonMetaDescription:
      "حوِّل تصدير RIS إلى CSL-JSON لمسارات عمل Pandoc وQuarto. الصق ملف .ris أو ارفعه، ونزِّل references.json — مجاني.",
    risToCslJsonIntro:
      "بالنسبة لمستخدمي Pandoc وQuarto، يُعَد CSL-JSON صيغة قائمة المراجع الأصلية. زوِّد هذه الصفحة بملف RIS الذي صدَّرته قاعدة بياناتك أو برنامجك، واحصل في المقابل على مصفوفة JSON مُهيكَلة — تُحلَّل كل السجلات محليًا، ولا يُرفَع شيء إلى أي مكان.",
    risToCslJsonUseCase:
      "يندمج في مسارات عمل docs-as-code: يرسل المراجعون مرفقات RIS، وملف الاستشهاد في مستودعك هو references.json، وهذه الصفحة هي حلقة الوصل.",
    cslJsonToBibtexTitle: "محوِّل CSL-JSON إلى BibTeX",
    cslJsonToBibtexMetaDescription:
      "حوِّل CSL-JSON (تصدير Pandoc أو Quarto أو Zotero) إلى BibTeX. الصق ملف .json أو ارفعه، ونزِّل ملف .bib — مجاني، داخل المتصفح.",
    cslJsonToBibtexIntro:
      "أحيانًا ينعكس المسار — قائمة مراجع وُلدت في مسار عمل Pandoc أو Zotero، وتحتاج إلى تغذية بناء بصيغة LaTeX. يقرأ هذا المحوِّل مصفوفة CSL-JSON في متصفحك، وينتج مدخلات BibTeX بأنواع وحقول مُعاد تخطيطها من نموذج CSL.",
    cslJsonToBibtexUseCase:
      "لمؤلف Quarto الذي يصرُّ شريكه في التأليف على استخدام Overleaf: أبقِ references.json مرجعًا معتمَدًا، وأنشئ ملف .bib عند الحاجة.",
    cslJsonToRisTitle: "محوِّل CSL-JSON إلى RIS",
    cslJsonToRisMetaDescription:
      "حوِّل CSL-JSON إلى RIS ليتمكَّن Zotero أو Mendeley أو EndNote من استيراده. الصق ملف .json أو ارفعه، ونزِّل ملف .ris — مجاني.",
    cslJsonToRisIntro:
      "يُعَد CSL-JSON رائعًا داخل مسارات عمل Pandoc، لكنه غامض بالنسبة لمعظم نوافذ الاستيراد في برامج إدارة المراجع. يجعل التحويل إلى RIS السجلات نفسها قابلة للاستيراد على نطاق واسع — يُخطَّط كل عنصر في متصفحك إلى وسوم TY/AU/TI، دون إرسال أي شيء إلى خادم.",
    cslJsonToRisUseCase:
      "مشكلة التسليم: قائمة مراجعك ملف references.json في مستودع git، ويطلب مشرفك أن تكون «بصيغة EndNote» بحلول الجمعة.",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "كل أنماط التوثيق",
    styleSingular: "نمط",
    stylePlural: "نمط",
    found: "من نتائج البحث",
    filterPlaceholder: "تصفية الأنماط...",
    noMatches: "لا توجد أنماط مطابقة لبحثك.",
    loadingMore: "جارٍ تحميل مزيد من الأنماط...",
    loadMore: "تحميل المزيد (المتبقي {count})",
    showingAll: "عرض كل الأنماط البالغ عددها {count}",
    internationalLabel: "دولي",
  },

  footer: {
    tagline:
      "مُولِّد مراجع مجاني يدعم {count} نمط. بلا حساب ودون اشتراك مدفوع وبلا حدود.",
    freeTools: "أدوات مجانية",
    resources: "مصادر",
    legal: "الشؤون القانونية",
    language: "اللغة",
    languageLabel: "اختر لغتك",
    rights: "تُنسَّق المراجع وفق التعريفات الرسمية لـ Citation Style Language.",
    popularStyles: "أنماط شائعة",
    about: "عن الموقع",
    privacy: "الخصوصية",
    terms: "الشروط",
    contact: "اتصل بنا",
    copyright: "© {year} CitationEasy. الاستخدام مجاني.",
    poweredBy: "مدعوم بـ",
    allTools: "كل أدوات الكتابة",
    citationGuides: "أدلة التوثيق",
    allStyles: "كل أنماط التوثيق",
    citationGlossary: "مسرد التوثيق",
    howToCiteAny: "كيف توثّق أي مصدر",
  },

  faq: {
    heading: "الأسئلة الشائعة",
    homeQ1: "هل CitationEasy مجاني فعلًا؟",
    homeA1:
      "نعم. CitationEasy مجاني بالكامل: بلا تسجيل وبلا حدود وبلا نسخة مدفوعة. جميع أنماط التوثيق البالغ عددها {count} متاحة للجميع.",
    homeQ2: "ما أنماط التوثيق المدعومة؟",
    homeA2:
      "جميع الأنماط البالغ عددها {count} من مشروع Citation Style Language، ومنها APA الإصدار السابع وMLA الإصدار التاسع وChicago وHarvard وVancouver وIEEE وAMA وTurabian.",
    homeQ3: "هل أحتاج إلى حساب؟",
    homeA3:
      "لا. يعمل CitationEasy بالكامل داخل متصفحك، وتُحفظ قائمة المراجع على جهازك أنت. لا يُرفع أي شيء إلى خادم، ولا يوجد تسجيل أصلًا.",
    homeQ4: "هل يمكنني توليد المراجع بلغتي؟",
    homeA4:
      "نعم. لغة المراجع إعداد منفصل عن لغة الموقع، فيمكنك العمل بالعربية بينما تُخرِج المراجع باللغة التي كُتب بها بحثك.",
    styleQ1: "هل مُولِّد مراجع {style} مجاني؟",
    styleA1:
      "نعم. توليد مراجع {style} مجاني وبلا حدود ولا يتطلب حسابًا. الصق معرّف DOI أو رابطًا أو رقم ISBN أو مدخل BibTeX، ثم انسخ المرجع الجاهز.",
    styleQ2: "كيف أوثّق مصدرًا بنمط {style}؟",
    styleA2:
      "الصق معرّف DOI أو الرابط أو رقم ISBN أو مدخل BibTeX الخاص بالمصدر في المُولِّد أعلى هذه الصفحة. نمط {style} مُحدَّد مسبقًا، فيظهر المرجع والإحالة داخل النص فورًا.",
    styleQ3: "ما مدى دقة تنسيق {style}؟",
    styleA3:
      "يُبنى كل مرجع من التعريف الرسمي لنمط {style} الصادر عن مشروع Citation Style Language — وهو الملف نفسه الذي يستخدمه Zotero وMendeley — لا من تقدير تقريبي للقواعد.",
  },

  tool: {
    modeLabel: "طريقة إدخال المرجع",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "البحث عن الكتب",
    modeArticles: "البحث عن المقالات",
    modeManual: "إدخال يدوي",
    errorEnterManually: "أدخل التفاصيل يدويًا",
    autoLabel:
      "الصق رابطًا أو مُعرِّف DOI أو PMID أو مُعرِّف arXiv أو رقم ISBN أو مدخل BibTeX",
    autoHint:
      "نتعرَّف على النوع تلقائيًا ونجلب البيانات الوصفية. الصق مُعرِّفًا واحدًا في كل سطر لتوثيق قائمة كاملة دفعةً واحدة.",
    generate: "إنشاء المرجع",
    generating: "جارٍ الإنشاء…",
    bookSearchLabel: "ابحث بالعنوان أو المؤلف أو رقم ISBN",
    bookSearchEmpty: "لا توجد نتائج بعد. اضغط «بحث» للعثور على الكتب.",
    bookSearchSource: "يبحث في فهرس Open Library الذي يضم ملايين الكتب",
    worksSearchLabel: "ابحث بعنوان المقالة أو بأسماء المؤلفين",
    worksSearchEmpty: "لا توجد نتائج بعد. اضغط «بحث» للعثور على المقالات.",
    worksSearchSource:
      "يبحث في فهرس Crossref: مقالات الدوريات وأوراق المؤتمرات وفصول الكتب",
    showingResults: "عرض {shown} من {total} نتيجة",
    search: "بحث",
    searching: "جارٍ البحث…",
    bulkResults: "نتائج التوثيق المجمَّع",
    copy: "نسخ",
    copied: "تم النسخ",
    copyHint: "انسخه والصقه في بحثك",
    resultTitle: "المرجع بعد التنسيق",
    edit: "تحرير",
    completeFields: "إكمال",
    fieldsIncomplete:
      "zero:لا حقول ناقصة|one:حقل واحد ناقص|two:حقلان ناقصان|few:{count} حقول ناقصة|many:{count} حقلًا ناقصًا|other:{count} حقل ناقص",
    outputLanguage: "اللغة",
    sourceType: "نوع المصدر",
    fieldAuthors: "المؤلف/المؤلفون",
    fieldAuthorsHint: "الأحمد، سارة أو سارة الأحمد",
    fieldTitle: "عنوان المقالة أو الكتاب",
    fieldBookTitle: "عنوان الكتاب",
    fieldBookTitleHint: "عنوان الكتاب أو المختارات",
    fieldEditors: "المحرِّر/المحرِّرون",
    fieldJournal: "الدورية / المطبوعة",
    fieldJournalHint: "اسم الدورية أو المطبوعة",
    fieldPublisher: "الناشر / الموقع",
    fieldPublisherHint: "اسم الناشر أو الموقع الإلكتروني",
    fieldDate: "التاريخ / السنة",
    fieldVolume: "المجلد",
    fieldIssue: "العدد",
    fieldPages: "الصفحات",
    fieldFormat: "الشكل / الوسيط",
    fieldAuthorsGroup: "مؤلف جماعي أو مؤسسة",
    fieldAuthorsGroupHint:
      "لإدراج جهة مع أشخاص، ضعها بين قوسين معقوفين: {R Core Team}، سارة الأحمد",
    fieldTranslators: "المترجم(ون)",
    fieldInterviewers: "المحاور(ون)",
    fieldVersion: "الإصدار",
    fieldCourt: "المحكمة",
    fieldIssuingAuthority: "الجهة المُصدِرة",
    fieldPatentNumber: "رقم براءة الاختراع",
    fieldEpisodeNumber: "رقم الحلقة",
    fieldLawNumber: "رقم القانون أو مشروع القانون",
    fieldReportNumber: "رقم التقرير",
    fieldReviewedTitle: "عنوان العمل موضوع المراجعة",
    fieldReviewedAuthors: "مؤلف(و) العمل موضوع المراجعة",
    inTextCitation: "الإحالة داخل النص",
    quickEdit: "تحرير سريع",
    quickEditHint: "حدِّث البيانات الوصفية وأعد إنشاء المرجع.",
    update: "تحديث",
    saving: "جارٍ الحفظ…",
    fieldAuthor: "المؤلف",
    fieldDateShort: "التاريخ",
    fieldTitleShort: "العنوان",
  },

  toolCollections: {
    "citation-generators": "مولدات التوثيق",
    "citation-tools": "أدوات التوثيق والمراجع",
    "paper-formatting": "تنسيق الأوراق البحثية",
    "essay-writing": "كتابة المقالات والأوراق البحثية",
    "writing-analysis": "تحليل الكتابة وتحريرها",
    "word-counters": "العدادات وسهولة القراءة",
    vocabulary: "المفردات والبحث عن الكلمات",
    "research-tools": "البحث والنشر",
    statistics: "حاسبات إحصائية",
    math: "حاسبات الرياضيات",
    science: "حاسبات العلوم والمختبر",
    charts: "المخططات والرسوم البيانية",
    economics: "الاقتصاد والأعمال والمالية",
    grades: "حاسبات المعدل التراكمي والدرجات",
    study: "الدراسة والإنتاجية",
    classroom: "الفصل الدراسي والمواد القابلة للطباعة",
    random: "المولدات والاختيار العشوائي",
    "text-tools": "تنظيف النص وتنسيقه",
    "fancy-text": "النص المزخرف والرموز",
    language: "اللغة والنقحرة",
    ciphers: "الرموز والشيفرات",
    converters: "محولات الوحدات والتواريخ والأرقام",
    developer: "البيانات ولغات الترميز والبرمجة",
  },
  bib: {
    title: "قوائم مراجعي",
    studioTitle: "استوديو قائمة المراجع",
    studioProjects: "المشاريع",
    studioExplore: "استكشاف",
    studioExploreIntro:
      "الأدلة والأدوات وكل أنماط الاستشهاد على بُعد نقرة واحدة.",
    studioStyleGuide: "دليل نمط {style}",
    studioStyleGuideHint: "القواعد والأمثلة وصيغة الاستشهاد داخل النص",
    studioGenerator: "مولّد الاستشهادات",
    studioNewProject: "مشروع جديد",
    studioSwitchProject: "تبديل المشروع",
    studioAddSource: "إضافة مصدر",
    studioAddSourceHint:
      "الصق DOI أو رابطًا أو ISBN، أو ابحث عن كتب ومقالات، أو أدخل البيانات يدويًا. كل ما تحفظه يُضاف إلى هذا المشروع.",
    studioDoneAdding: "تم",
    studioReferences: "المراجع",
    studioReferenceCount: "{count} مرجعًا",
    studioInspectorTitle: "تفاصيل المرجع",
    studioInspectorEmpty:
      "اختر مرجعًا لعرض الاستشهاد داخل النص والملاحظات وتفاصيل المصدر.",
    studioSavedLocally: "محفوظ في هذا المتصفح",
    studioOpen: "فتح استوديو المراجع",
    studioViewInStudio: "عرض في الاستوديو",
    studioFooterSaved: "{count} محفوظًا في استوديو المراجع",
    studioFooterEmpty:
      "الاستشهادات المحفوظة تُكوّن قائمة مراجع كاملة في الاستوديو",
    studioClearSelection: "إلغاء التحديد",
    studioDeleteSelected: "حذف المحدد",
    studioDeleteSelectedBody:
      "حذف {count} استشهادًا من «{name}»؟ لا يمكن التراجع عن هذا الإجراء.",
    studioDeletedMany: "تم حذف {count} استشهادًا",
    studioMoveTo: "نقل إلى",
    studioCopyTo: "نسخ إلى",
    studioSearchShortcut: "اضغط / للبحث",
    studioStyle: "النمط",
    studioCopyEntry: "نسخ المدخل",
    studioEntryCopied: "تم نسخ المدخل",
    studioSourceDetails: "تفاصيل المصدر",
    studioEmptyTitle: "هذا المشروع فارغ",
    studioEmptyBody:
      "أضف مصدرك الأول أعلاه، أو استورد مكتبة BibTeX أو RIS أو CSL-JSON موجودة.",
    studioBackup: "نسخة احتياطية",
    sharedTitle: "قائمة مراجع مشتركة",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    saved: "تم الحفظ",
    searchPlaceholder: "ابحث في المراجع…",
    empty: "لا توجد مراجع محفوظة بعد",
    emptySearch: "لا توجد مراجع تطابق بحثك.",
    countIn: "المراجع في {name}: {count}",
    savedOn: "حُفظ في {date}",
    emptyInBib:
      "لا توجد مراجع في قائمة المراجع هذه بعد. أنشئ مراجع واحفظها، أو استورد مكتبة BibTeX أو RIS أو CSL-JSON موجودة.",
    savedToast: "تم حفظ المرجع في قائمة المراجع",
    copyAll: "نسخ الكل",
    copyAllTitle: "نسخ جميع المراجع",
    export: "تصدير",
    exportTitle: "تصدير قائمة المراجع",
    import: "استيراد",
    importTitle: "استيراد مراجع",
    importLabel: "استيراد مراجع (BibTeX أو RIS أو CSL-JSON)",
    importing: "جارٍ الاستيراد…",
    importFailed: "فشل الاستيراد. حاول مرة أخرى.",
    importSummary:
      "تم الاستيراد: {added} · المكررات المتجاوزة: {duplicates} · فوق الحد: {overLimit} · الفاشلة: {failed}",
    importUnreadable: "تعذّرت قراءة الملف.",
    importUnparseable: "تعذّر استيراد المراجع.",
    importReviewTitle: "مراجعة الاستيراد",
    importReviewIntro: "راجع {total} مرجعًا بتنسيق {format} قبل تنسيقها وحفظها.",
    importReviewCount: "تم تضمين {included} من {total}",
    importSelectAll: "تضمين الكل",
    importExcludeAll: "استبعاد الكل",
    importLimitNotice: "لن يتم استيراد {count} مرجعًا يتجاوز حد 200 إدخال.",
    importDuplicateExisting: "تكرار محتمل للمرجع المحفوظ «{title}»",
    importDuplicateBatch: "تكرار محتمل للمرجع «{title}» في هذا الاستيراد",
    importMissingField: "{field} مفقود",
    importUntitled: "مرجع بلا عنوان",
    importReview: "مراجعة المراجع",
    importCommit: "تنسيق واستيراد",
    importBack: "رجوع",
    importOutcomeTitle: "اكتمل الاستيراد",
    importOutcomeSummary:
      "تمت الإضافة: {added} · تكرارات متجاهلة: {duplicates} · مستبعدة: {excluded} · فوق الحد: {overLimit} · فشلت: {failed}",
    sortBy: "الترتيب حسب",
    sortTitle: "ترتيب قائمة المراجع",
    sortAuthor: "المؤلف (أ–ي)",
    sortNewest: "تاريخ الإضافة (الأحدث)",
    sortOldest: "السنة (الأقدم أولًا)",
    sortManual: "ترتيب يدوي",
    backupAll: "نسخة احتياطية كاملة للمشروعات (.json)",
    backupDownloaded: "تم تنزيل النسخة الاحتياطية الكاملة",
    backupUnreadable: "تعذّرت قراءة ملف النسخة الاحتياطية.",
    restore: "استعادة",
    restoreTitle: "استعادة جميع مشروعات المراجع",
    restoreWarning:
      "سيتم التحقق من النسخة الاحتياطية أولًا، ثم استبدال جميع قوائم المراجع المحفوظة في هذا المتصفح. لا يمكن التراجع عن ذلك.",
    restoreChoose: "اختر نسخة CitationEasy احتياطية (.json)",
    replaceAndRestore: "استبدال واستعادة",
    restoreComplete: "تمت استعادة جميع مشروعات المراجع",
    restoreInvalid: "هذه ليست نسخة احتياطية صالحة لمشروع CitationEasy.",
    selectAllVisible: "تحديد كل ما هو ظاهر",
    selectedCount: "تم تحديد {count}",
    clusterOpen: "الاستشهاد معًا",
    clusterTitle: "استشهاد مركب داخل النص",
    clusterDescription:
      "أنشئ مجموعة استشهاد واحدة من المراجع المحددة. يتحكم النمط المختار في الترتيب وعلامات الترقيم والترقيم.",
    clusterTarget: "الناتج",
    clusterLocatorOptional: "موضع اختياري",
    clusterBuildCopy: "إنشاء الاستشهاد ونسخه",
    clusterBuilding: "جارٍ إنشاء الاستشهاد…",
    clusterCopied: "تم نسخ الاستشهاد المركب",
    clusterFailed: "تعذر إنشاء الاستشهاد المركب. يُرجى المحاولة مرة أخرى.",
    destination: "قائمة المراجع الوجهة",
    chooseDestination: "اختر قائمة مراجع…",
    copySelected: "نسخ",
    moveSelected: "نقل",
    copyComplete: "تم نسخ {count} استشهادات وتخطي {skipped} مكررات.",
    moveComplete: "تم نقل {count} استشهادات وبقيت {skipped} مكررات في المصدر.",
    selectCitation: "تحديد {title}",
    moveUp: "نقل لأعلى",
    moveDown: "نقل لأسفل",
    deleteTitle: "حذف المرجع",
    deleteConfirm: "حذف المرجع؟",
    deleted: "تم حذف المرجع",
    editTitle: "تحرير المرجع",
    close: "إغلاق",
    copiedAll: "تم نسخ جميع المراجع",
    copiedAnnotated: "تم نسخ قائمة المراجع المشروحة",
    copiedBibtex: "تم نسخ BibTeX",
    copiedBulleted: "تم نسخ القائمة النقطية",
    copiedNumbered: "تم نسخ القائمة المرقّمة",
    copiedHtml: "تم نسخ مقتطف HTML",
    downloadedWord: "تم تنزيل مستند Word",
    downloadedRtf: "تم تنزيل ملف RTF",
    downloadedRis: "تم تنزيل ملف RIS",
    downloadedCsl: "تم تنزيل ملف CSL-JSON",
    downloadedAnnotated: "تم تنزيل قائمة المراجع المشروحة",
    copyFailed: "تعذّر النسخ إلى الحافظة",
    shareCopied: "تم نسخ الرابط! يمكن لمن يملكه عرض هذه القائمة واستيرادها.",
    shareFailed: "تعذّر إنشاء رابط المشاركة",
    regenerateFailed: "تعذّر إعادة إنشاء المرجع",
    updateFailed: "تعذّر تحديث المرجع",
    fieldAuthor: "المؤلف",
    fieldTitle: "العنوان",
    fieldDate: "التاريخ",
    fieldPublisher: "الناشر",
    fieldVolume: "المجلد",
    fieldIssue: "العدد",
    fieldPages: "الصفحات",
    fieldUrl: "عنوان URL",
    fieldAccessed: "تاريخ الاطلاع",
    fieldEditor: "المحرر",
    fieldEvent: "مكان الحدث",
    noteLabel: "شرح لهذا المصدر",
    noteEdit: "تحرير هذه الملاحظة",
    notePlaceholder: "لخِّص المصدر وقيِّمه واذكر صلته ببحثك…",
    noteRemoved: "تمت إزالة الملاحظة",
    noteSave: "حفظ الملاحظة",
    noteCancel: "إلغاء",
    noteAdd: "إضافة ملاحظة",
    noteWords: "{count} كلمة",
    noteSaved: "تم حفظ الملاحظة ({count} كلمة)",
    noteClickToEdit: "انقر للتحرير",
    inTextCopy: "نسخ الإحالة داخل النص لهذا المصدر",
    inTextSelect: "حدِّد الإحالة أدناه لنسخها.",
    inTextFailed: "تعذّر إنشاء الإحالة داخل النص. حاول مرة أخرى.",
    locator: "موضع الاستشهاد",
    locatorType: "نوع الموضع",
    locatorPage: "صفحة",
    locatorChapter: "فصل",
    locatorSection: "قسم",
    locatorParagraph: "فقرة",
    locatorLine: "سطر",
    locatorVerse: "آية",
    reformat: "إعادة التنسيق",
    reformatTitle: "إعادة تنسيق كل المراجع بنمط آخر",
    reformatHeading: "إعادة تنسيق كل شيء بنمط واحد",
    reformatChoose: "اختر نمطًا…",
    reformatFailed: "فشلت إعادة التنسيق. قائمة مراجعك لم تتغيّر.",
    sortOrder: "معيار الترتيب",
    copyToClipboard: "نسخ إلى الحافظة",
    numberedList: "قائمة مرقّمة",
    bulletedList: "قائمة نقطية",
    htmlSnippet: "مقتطف HTML",
    copyWithAnnotations: "نسخ مع الشروح",
    wordAnnotated: "مستند Word مشروح (.doc)",
    downloadFile: "تنزيل الملف",
    wordDocument: "مستند Word (.doc)",
    copyShareLink: "نسخ رابط المشاركة",
    print: "طباعة…",
    printFailed: "حُظرت النافذة المنبثقة — اسمح بها للطباعة",
    font: "الخط",
    sitePublication: "اسم الموقع / المنشور",
    importIntro:
      "الصق ملف BibTeX (.bib) أو RIS (.ris) أو CSL-JSON (.json) أو ارفعه",
    importUpload: "ارفع ملف .bib أو .ris أو .json",
    importPaste: "أو الصق BibTeX أو RIS أو CSL-JSON",
    cancel: "إلغاء",
    done: "تم",
    delete: "حذف",
    deleteBody: "سيُحذف هذا المرجع نهائيًا من قائمة مراجعك.",
    editBody: "حدِّث البيانات الوصفية واحفظ لإعادة إنشاء المرجع.",
    reformatExplain:
      "يعيد بناء كل المدخلات ({count}) من بيانات المصدر المحفوظة — لا يُعاد تنزيل أي شيء ولا يُفقد أي مصدر.",
    inTextHeading: "الإحالة داخل النص",
    inTextLocatorHint:
      "أضف رقم صفحة أو موضعًا آخر لربط الإحالة بموضع في المصدر — تشترط ذلك معظم الأنماط عند الاقتباس المباشر. اتركه فارغًا للصيغة البسيطة.",
    inTextCopyButton: "نسخ الإحالة داخل النص",
    mixedStyles:
      "تخلط قائمة المراجع هذه بين {count} من أنماط التوثيق ({styles}).",
    mixedStylesAction: "استخدم {action} لتوحيدها جميعًا بنمط واحد قبل التسليم.",
    selectBibliography: "اختر قائمة مراجع",
    newBibliography: "قائمة مراجع جديدة",
    moreOptions: "خيارات إضافية",
    rename: "إعادة التسمية",
    removeDuplicates: "إزالة المكررات",
    cannotDeleteOnly: "لا يمكنك حذف قائمة المراجع الوحيدة",
    newBibliographyBody: "أنشئ قائمة مراجع لبحث أو مشروع آخر.",
    bibliographyName: "اسم قائمة المراجع",
    create: "إنشاء",
    renameBibliography: "إعادة تسمية قائمة المراجع",
    renameBibliographyBody: "أدخل اسمًا جديدًا لـ «{name}».",
    newName: "الاسم الجديد",
    duplicateRemovedOne: "تمت إزالة تكرار واحد ({count})",
    duplicateRemovedMany: "تمت إزالة {count} مكررات",
    noDuplicates: "لم يُعثر على مراجع مكررة",
    removeDuplicatesConfirm: "إزالة المراجع المكررة؟",
    removeDuplicatesBody:
      "يفحص هذا الخيار «{name}» بحثًا عن المصدر نفسه (باستخدام DOI أو ISBN أو العنوان والسنة والمؤلف) ويُبقي نسخة واحدة. تبقى المراجع التي يتعذر مطابقتها دون تغيير.",
    deleteBibliographyConfirm: "حذف قائمة المراجع؟",
    deleteBibliographyBody:
      "سيؤدي ذلك إلى حذف «{name}» وكل المراجع الموجودة فيها ({count}) نهائيًا.",
  },

  bibliographyPage: {
    metaTitle: "استوديو قائمة المراجع - تنظيم المراجع وشرحها وتصديرها",
    metaDescription:
      "أنشئ مشاريع مراجع خاصة وأدرها في متصفحك. ابحث ورتّب وأضف الشروح وعدّل وأعد التنسيق واستورد وصدّر وشارك دون حساب.",
    keyword1: "منشئ قائمة مراجع",
    keyword2: "مدير المراجع",
    keyword3: "أداة قائمة مراجع مشروحة",
    ogTitle: "استوديو قائمة المراجع",
    ogDescription:
      "مساحة عمل خاصة بصفحة كاملة لتنظيم المراجع وتنسيقها وشرحها واستيرادها وتصديرها.",
    ogImageTitle: "استوديو قائمة المراجع",
    ogImageSubtitle: "نظّم مراجعك واشرحها وأعد تنسيقها وصدّرها وشاركها.",
    ogKind: "مساحة عمل للمراجع",
    breadcrumb: "استوديو قائمة المراجع",
    eyebrow: "مساحة عمل خاصة داخل المتصفح",
    lead: "أدر جميع مراجع بحثك في مكان واحد. تبقى مشاريعك في هذا المتصفح ما لم تختر تصديرها أو مشاركتها.",
    privacyTitle: "خاص افتراضيًا",
    privacyBody:
      "تستخدم المشاريع والشروح التخزين المحلي للمتصفح. تتضمن روابط المشاركة المراجع لكنها تستبعد الملاحظات الخاصة عمدًا.",
    workflowTitle: "من قائمة المصادر إلى البحث النهائي",
    workflowBody:
      "بدّل بين المشاريع وابحث عن المراجع ورتّبها وأضف الشروح أو المواضع وصحّح البيانات الوصفية وأعد تنسيق القائمة كلها بنمط واحد.",
    formatsTitle: "استورد مراجعك وانقلها إلى أي مكان",
    formatsBody:
      "استورد BibTeX أو RIS أو CSL-JSON. انسخ القوائم المنسقة أو صدّر Word وRTF وRIS وCSL-JSON وHTML وBibTeX والنسخ المشروحة.",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - التعريف والأمثلة",
    notFoundTitle: "المصطلح غير موجود",
    keywordDefinition: "تعريف {term}",
    keywordWhatIs: "ما هو {term}",
    ogTitle: "{term} - مسرد CitationEasy",
    ogKind: "مسرد التوثيق",
    breadcrumb: "المسرد",
    alsoCalled: "يُعرف أيضًا باسم: {aliases}",
    doItHeading: "جرِّبه على CitationEasy",
    seeAlsoHeading: "انظر أيضًا",
    moreInHeading: "مزيد من مصطلحات {category}",
    navLabel: "تصفح المسرد",
    allTermsLink: "كل مصطلحات المسرد ({count})",
    generatorLink: "مُولِّد مراجع مجاني",
    termSetName: "مسرد CitationEasy للتوثيق",
    hubMetaTitle: "مسرد التوثيق - شرح {count} مصطلح",
    hubMetaDescription:
      "تعريفات بلغة بسيطة لـ {count} مصطلح في التوثيق والكتابة الأكاديمية: et al.، ibid.، DOI، الإزاحة المعلقة، النسخ المُجمَّع من مصادر متعددة، النسخة الرسمية المنشورة، وغيرها — مع أمثلة لكل مصطلح.",
    hubKeyword1: "مسرد التوثيق",
    hubKeyword2: "مصطلحات التوثيق",
    hubKeyword3: "مسرد الكتابة الأكاديمية",
    hubKeyword4: "ماذا تعني et al",
    hubKeyword5: "ما هو DOI",
    hubKeyword6: "مصطلحات التوثيق والإحالة",
    hubOgTitle: "مسرد التوثيق",
    hubOgDescription:
      "تعريفات {count} مصطلح في التوثيق والكتابة الأكاديمية، مع أمثلة.",
    hubOgImageTitle: "مسرد التوثيق",
    hubOgImageSubtitle:
      "{count} مصطلح في التوثيق والكتابة الأكاديمية، مُعرَّفة بلغة بسيطة مع أمثلة.",
    hubOgKind: "مرجع",
    hubTermSetDescription:
      "تعريفات {count} مصطلح في التوثيق والإحالة والكتابة الأكاديمية.",
    hubCollectionName: "مسرد التوثيق",
    hubCollectionDescription:
      "تعريفات بلغة بسيطة لـ {count} مصطلح في التوثيق والكتابة الأكاديمية.",
    hubHeading: "مسرد التوثيق",
    hubIntro:
      "{count} مصطلح من عالم التوثيق والكتابة الأكاديمية، مُعرَّفة بلغة بسيطة مع أمثلة — الاختصارات التي تظهر في أدلة الأنماط، وعناصر المرجع، والمُعرِّفات التي تحدِّد المصدر بدقة، ومفردات النشر العلمي.",
    hubJumpLabel: "انتقل إلى حرف",
    hubBrowseHeading: "تصفح حسب الموضوع",
    hubAllHeading: "كل المصطلحات (A–Z)",
    hubWorkHeading: "استخدم هذه المصطلحات عمليًا",
    hubWorkGenerator: "مُولِّد مراجع مجاني",
    hubWorkStyles: "أدلة أنماط التوثيق",
    hubWorkHowTo: "كيفية توثيق أي مصدر",
    hubWorkCompare: "قارِن أنماط التوثيق",
    hubWorkTools: "أدوات الكتابة والتوثيق",
    hubWorkFaq: "الأسئلة الشائعة عن التوثيق",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle:
      "الأسئلة الشائعة عن التوثيق - إجابات سريعة عن أسئلة التوثيق الشائعة",
    metaDescription:
      "إجابات سريعة ودقيقة عن أسئلة التوثيق التي يطرحها الطلاب فعلًا: مُعرِّفات DOI، المصادر بلا مؤلف، et al.، الإزاحة المعلقة، توثيق الذكاء الاصطناعي، قواعد الانتحال، الفرق بين APA وMLA، وغيرها — مع روابط إلى الأدلة الكاملة.",
    ogTitle: "الأسئلة الشائعة عن التوثيق",
    ogDescription:
      "إجابات سريعة عن أكثر أسئلة التوثيق شيوعًا، من مُعرِّفات DOI وet al. إلى توثيق ChatGPT.",
    ogImageTitle: "أسئلة وأجوبة عن التوثيق",
    ogImageSubtitle:
      "إجابات قصيرة ودقيقة عن أسئلة التوثيق التي يطرحها الطلاب فعلًا.",
    ogKind: "الأسئلة الشائعة",
    breadcrumbLabel: "مسار التصفح",
    breadcrumbHome: "الرئيسية",
    breadcrumbCurrent: "الأسئلة الشائعة عن التوثيق",
    heading: "الأسئلة الشائعة عن التوثيق",
    intro:
      "إجابات سريعة ودقيقة عن أسئلة التوثيق التي يطرحها الطلاب فعلًا — مع روابط إلى الدليل الكامل أو الأداة المناسبة عند الحاجة إلى مزيد من التفصيل.",
    contentsLabel: "محتويات الأسئلة الشائعة",
    stillStuckHeading: "ما زلت محتارًا؟",
    stillStuckBody:
      "تصفَّح [مكتبة الأدلة الكاملة](/guides)، أو راجِع [الأوراق المرجعية السريعة للأنماط](/cheat-sheets)، أو ابحث عن مصطلح في [مسرد التوثيق](/glossary)، أو [ابحث في الموقع كله](/search)، أو ببساطة [أنشئ المرجع](/) ودَع المُولِّد يطبِّق القواعد نيابةً عنك.",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle: "أوراق مرجعية سريعة لأنماط التوثيق - أدلة مرجعية سريعة",
    hubMetaDescription:
      "أوراق مرجعية سريعة لأنماط التوثيق APA وMLA وChicago. أدلة مناسبة للطباعة مع أمثلة لأنواع المصادر الشائعة.",
    hubBreadcrumbHome: "الرئيسية",
    hubBreadcrumbCurrent: "أوراق مرجعية سريعة لأنماط التوثيق",
    hubBackLink: "→ العودة إلى المُولِّد",
    hubHeading: "أوراق مرجعية سريعة لأنماط التوثيق",
    hubIntro:
      "أدلة مرجعية سريعة لأكثر أنماط التوثيق شيوعًا. مناسبة للطباعة ومحدَّثة دائمًا.",
    hubApaTitle: "ورقة APA السابع المرجعية السريعة",
    hubApaDesc: "علم النفس، العلوم الاجتماعية، التربية، التمريض",
    hubMlaTitle: "ورقة MLA التاسع المرجعية السريعة",
    hubMlaDesc: "الأدب، اللغات، العلوم الإنسانية، الدراسات الثقافية",
    hubChicagoTitle: "ورقة Chicago المرجعية السريعة",
    hubChicagoDesc: "التاريخ، تاريخ الفن، الفلسفة، الأديان",
    backToSheets: "→ العودة إلى الأوراق المرجعية",
    generalRules: "القواعد العامة",
    inTextCitations: "الإحالات داخل النص",
    colSituation: "الحالة",
    colFormat: "الصيغة",
    colExample: "المثال",
    book: "كتاب",
    journalArticle: "مقالة دورية",
    website: "موقع إلكتروني",
    apaMetaTitle: "ورقة APA السابع المرجعية السريعة - دليل مرجعي سريع",
    apaMetaDescription:
      "ورقة مرجعية سريعة لتوثيق APA السابع مع أمثلة للكتب والدوريات والمواقع الإلكترونية وغيرها. مرجع سريع مناسب للطباعة.",
    apaHeading: "ورقة APA السابع المرجعية السريعة",
    apaLead: "مرجع سريع لأكثر صيغ توثيق APA شيوعًا.",
    apaRule1:
      "استخدم **الإزاحة المعلقة** (السطر الأول من الهامش، وبقية الأسطر مُزاحة 0.5 بوصة)",
    apaRule2: "استخدم تباعدًا مزدوجًا لكل المدخلات",
    apaRule3: "رتِّب أبجديًا حسب اسم عائلة المؤلف",
    apaRule4: "استخدم الخط المائل لعناوين الكتب والدوريات والمجلدات",
    apaRule5: "استخدم مُعرِّف DOI عند توفُّره",
    apaRow1Situation: "مؤلف واحد",
    apaRow1Format: "(Author, Year)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "مؤلفان اثنان",
    apaRow2Format: "(Author & Author, Year)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "ثلاثة مؤلفين أو أكثر",
    apaRow3Format: "(First Author et al., Year)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "اقتباس مباشر",
    apaRow4Format: "(Author, Year, p. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "بلا مؤلف",
    apaRow5Format: '("Title," Year)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "أمثلة على قائمة المراجع",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "فصل من كتاب بتحرير محرِّر",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "ورقة مؤتمر",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "أبرز الفروق عن APA السادس",
    apaDifference1: 'لا حاجة إلى "Retrieved from" قبل الروابط',
    apaDifference2: "أدرِج مُعرِّف DOI بصيغة رابط https://doi.org/",
    apaDifference3: "يُدرَج حتى 20 مؤلفًا قبل استخدام علامة الحذف",
    apaDifference4: "لم يعد مكان الناشر مطلوبًا",
    apaDifference5: 'استخدم "they" بصيغة المفرد للغة محايدة الجنس',
    apaCtaText: "أنشئ مراجع APA مثالية تلقائيًا",
    apaCtaButton: "مُولِّد مراجع APA ←",
    mlaMetaTitle: "ورقة MLA التاسع المرجعية السريعة - دليل مرجعي سريع",
    mlaMetaDescription:
      "ورقة مرجعية سريعة لتوثيق MLA التاسع مع أمثلة للكتب والمقالات والمواقع الإلكترونية وغيرها. مرجع سريع مناسب للطباعة.",
    mlaHeading: "ورقة MLA التاسع المرجعية السريعة",
    mlaLead: "مرجع سريع لأكثر صيغ توثيق MLA شيوعًا.",
    mlaRule1: "استخدم **الإزاحة المعلقة**",
    mlaRule2: "استخدم تباعدًا مزدوجًا لكل المدخلات",
    mlaRule3: "رتِّب أبجديًا حسب اسم عائلة المؤلف",
    mlaRule4: 'ضَع لصفحة المراجع عنوان "Works Cited" (الأعمال المُستشهَد بها)',
    mlaRule5:
      "استخدم الخط المائل لعناوين الحاويات (الكتب، الدوريات، المواقع الإلكترونية)",
    mlaRow1Situation: "مؤلف واحد",
    mlaRow1Format: "(Author Page)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "مؤلفان اثنان",
    mlaRow2Format: "(Author and Author Page)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "ثلاثة مؤلفين أو أكثر",
    mlaRow3Format: "(First Author et al. Page)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "بلا مؤلف",
    mlaRow4Format: '("Title" Page)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "بلا رقم صفحة",
    mlaRow5Format: "(Author)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "أمثلة على الأعمال المُستشهَد بها",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "مختارات/كتاب بتحرير محرِّر",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "عناصر MLA الأساسية (بالترتيب)",
    mlaCore1: "Author.",
    mlaCore2: '"Title of Source."',
    mlaCore3: "*Title of Container*,",
    mlaCore4: "Contributors,",
    mlaCore5: "Version,",
    mlaCore6: "Number,",
    mlaCore7: "Publisher,",
    mlaCore8: "Publication date,",
    mlaCore9: "Location (pages, URL, DOI).",
    mlaCtaText: "أنشئ مراجع MLA مثالية تلقائيًا",
    mlaCtaButton: "مُولِّد مراجع MLA ←",
    chicagoMetaTitle: "ورقة Chicago المرجعية السريعة - دليل مرجعي سريع",
    chicagoMetaDescription:
      "ورقة مرجعية سريعة لتوثيق دليل Chicago مع أمثلة على نظامَي الحواشي وقائمة المراجع والمؤلف والتاريخ. مرجع سريع مناسب للطباعة.",
    chicagoHeading: "ورقة Chicago المرجعية السريعة",
    chicagoLead: "مرجع سريع لصيغ توثيق دليل Chicago (الطبعة الثامنة عشرة).",
    chicagoSystemsHeading: "نظاما Chicago",
    chicagoColNb: "الحواشي وقائمة المراجع (NB)",
    chicagoColAd: "المؤلف والتاريخ (AD)",
    chicagoRow1Nb: "حواشٍ سفلية/ختامية + قائمة مراجع",
    chicagoRow1Ad: "إحالات بين قوسين + قائمة مراجع",
    chicagoRow2Nb: "التاريخ، الفنون، العلوم الإنسانية",
    chicagoRow2Ad: "العلوم، العلوم الاجتماعية",
    chicagoRow3Nb: "الحواشي الأولى أكثر تفصيلًا",
    chicagoRow3Ad: "مشابه لصيغة APA",
    chicagoExamplesHeading: "أمثلة على الحواشي وقائمة المراجع",
    chicagoNoteLabel: "الحاشية:",
    chicagoBibliographyLabel: "قائمة المراجع:",
    chicagoBookLabel: "كتاب (حاشية سفلية)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "مقالة دورية (حاشية سفلية)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "موقع إلكتروني (حاشية سفلية)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "الحواشي المختصرة",
    chicagoShortIntro: "بعد الإحالة الكاملة الأولى، استخدم حواشٍ سفلية مختصرة:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "أهم قواعد التنسيق",
    chicagoRule1: "استخدم أرقامًا مرفوعة للإحالة إلى الحواشي في النص",
    chicagoRule2: "مدخلات قائمة المراجع تستخدم الإزاحة المعلقة",
    chicagoRule3:
      'للإحالات المتتالية إلى المصدر نفسه، استخدم حاشية مختصرة بدلًا من "Ibid." (نفسه)',
    chicagoRule4:
      "العناوين: الكتب والدوريات مائلة، والمقالات والفصول بين علامتَي اقتباس",
    chicagoRule5: "استخدم تواريخ الوصول للمصادر الإلكترونية القابلة للتغيير",
    chicagoCtaText: "أنشئ مراجع Chicago مثالية تلقائيًا",
    chicagoCtaButton: "مُولِّد مراجع Chicago ←",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "الصفحات الأساسية",
    styleLanding: "صفحات أنماط التوثيق الرئيسية",
    style: "صفحات مرجعية لأنماط التوثيق",
    styleExamples: "صفحات أمثلة على التوثيق",
    styleFormat: "أدلة تنسيق الأبحاث",
    styleInText: "أدلة الإحالة داخل النص",
    styleAnnotatedBibliography: "أدلة قوائم المراجع المشروحة",
    styleReferencePage: "أدلة صفحات المراجع/الأعمال المُستشهَد بها",
    tool: "أدوات كتابة وتوثيق مجانية",
    guide: "أدلة تعليمية",
    guideCategory: "فئات الأدلة",
    toolCollection: "مجموعات الأدوات",
    howToCite: "كيفية توثيق <source> بنمط <style>",
    comparison: "مقارنات بين أنماط التوثيق",
    converter: "أدوات تحويل المُعرِّفات والصيغ",
    field: "أنماط التوثيق حسب المجال الأكاديمي",
    region: "أنماط التوثيق حسب الدولة/المنطقة",
    category: "أنماط التوثيق حسب الفئة الموضوعية",
    cheatSheet: "أوراق مرجعية سريعة من صفحة واحدة",
    glossary: "مسرد مصطلحات التوثيق والكتابة الأكاديمية",
  },

  // /about
  aboutPage: {
    metaTitle: "عن CitationEasy - مُولِّد مراجع مجاني",
    metaDescription:
      "CitationEasy مُولِّد مراجع مجاني يدعم {count} نمط. بناه Samuel Sergi باستخدام أدوات مفتوحة المصدر مثل Citation Style Language وCitation.js وNext.js.",
    backLink: "→ العودة إلى المُولِّد",
    heading: "عن CitationEasy",
    intro:
      "CitationEasy مُولِّد مراجع مجاني ومفتوح الوصول، صُمِّم للطلاب والباحثين والكتّاب الأكاديميين. يدعم **{count} نمط توثيق** ويوفِّر مجموعة متنامية من أدوات الكتابة والأدلة التعليمية ومصادر المراجع — كل ذلك من دون الحاجة إلى تسجيل أو اشتراك.",
    offerHeading: "ما الذي نقدِّمه",
    offer1:
      "[مُولِّد مراجع](/) يدعم {count} نمط، منها APA السابع وMLA التاسع وشيكاغو الثامن عشر وHarvard وVancouver وIEEE، وآلاف الأنماط الأخرى",
    offer2:
      "[40 أداة مجانية للكتابة والتوثيق](/tools) — عداد الكلمات، فاحص سهولة القراءة، أداة التحقق من DOI، أداة ترتيب قائمة المراجع أبجديًا، وغيرها",
    offer3:
      "[750 دليل كيفية توثيق](/how-to-cite) يغطي كل نوع مصدر رئيسي عبر 6 أنماط توثيق",
    offer4:
      "[أكثر من 100 دليل تعليمي](/guides) عن أفضل ممارسات التوثيق والكتابة الأكاديمية ومهارات البحث",
    offer5:
      "[أداة مقارنة الأنماط](/compare)، و[اختبار نمط التوثيق](/quiz)، و[الأوراق المرجعية السريعة](/cheat-sheets) للرجوع السريع",
    offer6:
      "7 صيغ للتصدير: نص عادي، BibTeX، Word، قائمة مرقّمة، قائمة نقطية، RIS، وCSV",
    openSourceHeading: "مبني على تقنيات مفتوحة المصدر",
    openSourceIntro:
      "CitationEasy ممكن بفضل عدد من المشاريع وواجهات البرمجة المفتوحة المصدر الممتازة. نؤمن بضرورة نسبة الفضل لأصحابه:",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — المعيار المفتوح الذي يشغِّل أنماط التوثيق البالغ عددها {count} لدينا. يحافظ على CSL مجتمع من المتطوعين، وتستخدمه برامج إدارة المراجع مثل Zotero وMendeley وPapers. تأتي تعريفات الأنماط من [مستودع أنماط CSL](https://github.com/citation-style-language/styles) على GitHub.",
    openSource2:
      "[Citation.js](https://citation.js.org/) — مكتبة JavaScript التي تعالج المراجع وتنسِّقها وفق أنماط CSL. أنشأها Lars Willighagen.",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — واجهة برمجة مجانية للبحث عن الكتب توفِّرها Internet Archive، تُستخدَم للبحث عن بيانات الكتب الوصفية بالعنوان أو رقم ISBN.",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — نظام مُعرِّف الكائن الرقمي المستخدَم في تحليل مُعرِّفات DOI والتحقق منها.",
    createdHeading: "من أنشأه",
    createdBody:
      "أنشأ **Samuel Sergi** موقع CitationEasy ويتولى صيانته. الهدف بسيط: توفير أداة توثيق مجانية حقًا وعالية الجودة، لا تحجب الميزات خلف جدار دفع ولا تتطلب حسابًا.",
    contactPrompt: "لديك أسئلة أو ملاحظات أو اقتراحات؟ تواصل معنا:",
    contactEmail:
      "البريد الإلكتروني: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "مهمتنا",
    mission1:
      "لا ينبغي أن تكون المراجع الدقيقة مكلفة. تُعلن أدوات توثيق كثيرة أنها مجانية لكنها تقيِّد صيغ التصدير، أو تحدّ من عدد المراجع، أو تدفع المستخدمين نحو خطط مدفوعة. يلتزم CitationEasy بأن يكون مجانيًا تمامًا — بلا تسجيل، وبلا حدود، وبلا مستوى مدفوع.",
    mission2:
      "كل ميزة في هذا الموقع، من مُولِّد المراجع إلى أدوات الكتابة والأدلة التعليمية، متاحة للجميع مجانًا. نؤمن بأن أدوات النزاهة الأكاديمية يجب أن تكون في متناول كل الطلاب والباحثين، بصرف النظر عن ميزانيتهم.",
  },

  // /contact
  contactPage: {
    metaTitle: "اتصل بنا",
    metaDescription:
      "تواصل مع CitationEasy. أسئلة أو ملاحظات أو اقتراحات حول مُولِّد المراجع المجاني وأدوات الكتابة لدينا؟ يسعدنا سماع رأيك.",
    backLink: "→ العودة إلى المُولِّد",
    heading: "اتصل بنا",
    intro:
      "لديك أسئلة أو ملاحظات أو اقتراحات حول CitationEasy؟ يسعدنا سماع رأيك. سواء وجدت خللًا، أو لديك طلب ميزة جديدة، أو تحتاج مساعدة في مرجع، فلا تتردد في التواصل معنا.",
    touchHeading: "تواصل معنا",
    touchBody:
      "أفضل طريقة للتواصل معنا هي عبر البريد الإلكتروني. نسعى للرد خلال 48 ساعة.",
    emailLine:
      "**البريد الإلكتروني:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "أسئلة شائعة",
    commonIntro: "قبل التواصل معنا، قد تجد إجابة سؤالك في أحد هذه المصادر:",
    resource1:
      "[أدلة التوثيق](/guides) — تعليمات خطوة بخطوة لتوثيق المصادر بكل الأنماط الرئيسية",
    resource2:
      "[أدلة كيفية التوثيق](/how-to-cite) — 750 توليفة من أنواع المصادر والأنماط مع أمثلة",
    resource3:
      "[الأوراق المرجعية السريعة](/cheat-sheets) — مرجع سريع لتنسيقات APA وMLA وChicago",
    resource4:
      "[أدوات الكتابة](/tools) — عداد الكلمات، فاحص سهولة القراءة، أداة التحقق من DOI، وغيرها",
    issueHeading: "الإبلاغ عن مشكلة",
    issueIntro:
      "إذا وجدت خطأ في تنسيق مرجع، أو ميزة معطَّلة، أو نمطًا غير صحيح، يُرجى تضمين أكبر قدر ممكن من التفاصيل عند التواصل معنا:",
    issue1: "نمط التوثيق الذي كنت تستخدمه",
    issue2: "نوع المصدر (كتاب، موقع إلكتروني، مقالة دورية، إلخ)",
    issue3: "ما كنت تتوقعه مقابل ما تم إنشاؤه فعليًا",
    issue4: "متصفحك وجهازك (إن كان ذا صلة)",
    issueOutro: "هذا يساعدنا على تحديد المشكلة وإصلاحها بسرعة.",
    aboutHeading: "عن CitationEasy",
    aboutBody:
      "CitationEasy مُولِّد مراجع مجاني يدعم أكثر من عشرة آلاف نمط توثيق. أنشأه Samuel Sergi بهدف إتاحة مراجع دقيقة للجميع. اعرف المزيد في [صفحة نبذة عنا](/about).",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "CitationEasy لمساعدات الذكاء الاصطناعي والوكلاء - API وخادم MCP وllms.txt",
    metaDescription:
      "استخدم CitationEasy برمجيًا: واجهة برمجة JSON مجانية لا تتطلب مصادقة لإنشاء مراجع بـ {count} نمط، وخادم MCP للوكلاء، وllms.txt، ووصف OpenAPI، وعروض markdown لكل صفحة.",
    keyword1: "واجهة برمجة التوثيق",
    keyword2: "خادم MCP",
    keyword3: "واجهة برمجة مُولِّد المراجع",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "مراجع وكلاء الذكاء الاصطناعي",
    keyword7: "واجهة برمجة توثيق مجانية",
    webApiDescription:
      "واجهة برمجة JSON مجانية لا تتطلب مصادقة، تنسِّق المراجع بـ {count} نمط من أنماط Citation Style Language انطلاقًا من رابط أو DOI أو ISBN أو PubMed ID أو arXiv ID أو بيانات CSL-JSON وصفية.",
    breadcrumb: "للذكاء الاصطناعي والوكلاء",
    heading: "CitationEasy لمساعدات الذكاء الاصطناعي والوكلاء",
    intro:
      "كل ما في هذا الموقع متاح للبرمجيات كما هو متاح للأشخاص: واجهة برمجة JSON مجانية، وخادم MCP، ووصف OpenAPI، وفهرس llms.txt، وعرض markdown لكل الصفحات البالغ عددها {count}. بلا مفتاح، وبلا حساب، وبلا أي حد لمعدل الطلبات نفرضه نحن.",
    whyHeading: "لماذا تستدعي واجهة البرمجة بدلًا من كتابة المرجع بنفسك",
    whyBody:
      "يبدو تنسيق المراجع وكأنه مسألة توليد نص، لكنه ليس كذلك. يُشفِّر كل نمط مئات القواعد المتعلقة بعكس ترتيب اسم المؤلف، والأحرف الأولى، وحالة أحرف العنوان، وعلامات ترقيم الحاوية، وبيانات الطبعة، وموضع التاريخ، وتختلف هذه القواعد بطرق يسهل إخطاؤها عن طريق الذاكرة. يُشغِّل CitationEasy مكتبة **citeproc-js** وفق تعريفات Citation Style Language الرسمية — وهي المحرك نفسه الذي يستخدمه Zotero وMendeley — لذا يكون الناتج حتميًا ومطابقًا لما يتوقعه نظام تقديم البحوث الخاص بالمجلة. تأتي البيانات الوصفية من Crossref وOpen Library وPubMed؛ لا شيء يُختلَق، وأي حقل مفقود من المصدر يبقى مفقودًا في الناتج بدلًا من ملئه بتخمين معقول.",
    generateHeading: "أنشئ مرجعًا",
    generateBody:
      "أرسِل `inputs` بدلًا من `input` لمعالجة حتى 10 مصادر في استدعاء واحد، أو أرسِل `entry` ببيانات CSL-JSON التي تملكها بالفعل لتجاوز عملية البحث بالكامل. أضِف `note: true` للحصول على صيغة الحاشية السفلية. تُرجَع أخطاء كل مصدر على حدة، لذا لا تفشل الدفعة بأكملها أبدًا.",
    mcpHeading: "الاتصال عبر MCP",
    mcpIntro:
      "تتحدث نقطة نهاية Model Context Protocol عند `/api/mcp` بروتوكول JSON-RPC 2.0 عبر HTTP القابل للبث، ولا تتطلب أي بيانات اعتماد.",
    mcpToolsHeading: "الأدوات التي توفرها",
    endpointsHeading: "نقاط النهاية",
    colEndpoint: "نقطة النهاية",
    colWhat: "وظيفتها",
    endpointCite:
      "تنسِّق حتى 10 مصادر دفعة واحدة. تقبل رابطًا أو DOI أو ISBN أو PubMed ID أو arXiv ID أو نص BibTeX/RIS/CSL-JSON، أو كائن مدخل CSL-JSON. تُرجِع مدخل المرجع، واختياريًا الإحالة داخل النص والحاشية السفلية.",
    endpointStyles:
      "تبحث في كل الأنماط البالغ عددها {count} بالاسم أو فئة تنسيق التوثيق أو المجال أو المنطقة.",
    endpointStyleSlug:
      "نمط واحد بالتفصيل، مع أمثلة حقيقية منسَّقة تولَّدت من تعريف CSL الخاص به.",
    endpointSearch: "بحث مرتَّب حسب الصلة عبر كل صفحة في الموقع.",
    endpointPages:
      "كتالوج الموقع الكامل كمدخلات مُهيكَلة، قابل للتصفية حسب نوع الصفحة.",
    endpointHowToCite:
      "كل صفحة إرشادية من نوع «مصدر × نمط»، قابلة للتصفية حسب أي منهما.",
    endpointTools: "كل أداة مجانية، مع فئتها وكلماتها المفتاحية.",
    endpointGuides: "كل دليل تعليمي، مع فئته.",
    endpointConverters: "كل عملية تحويل للمُعرِّفات والصيغ يوفرها الموقع.",
    endpointComparisons:
      "مقارنات جنبًا إلى جنب بين الأنماط، مرتبطة بسجلَّي كلا النمطين.",
    endpointFields:
      "المجالات الأكاديمية والفئات الموضوعية والمناطق — للإجابة عن سؤال «ما النمط الذي يجب أن أستخدمه؟».",
    endpointFaq:
      "إجابات مُتحقَّق منها عن أسئلة التوثيق الشائعة، قابلة للتصفية عبر q.",
    endpointGlossary:
      "مصطلحات التوثيق والكتابة الأكاديمية مع تعريفاتها الكاملة — تحمل الاستجابة النص نفسه، فلا حاجة إلى جلب صفحة بعد ذلك.",
    endpointIndex: "مستند اكتشاف نقاط النهاية. ابدأ من هنا إذا كنت تستكشف.",
    discoveryHeading: "ملفات الاكتشاف",
    discoveryLlms: "فهرس مُنتقًى للموقع مكتوب للنماذج اللغوية.",
    discoveryLlmsFull:
      "كل صفحة ينشرها الموقع، مُجمَّعة حسب النوع، سطر واحد لكل صفحة.",
    discoveryOpenapi: "وصف OpenAPI 3.1 لواجهة البرمجة العامة كاملةً.",
    discoveryMcp:
      "نقطة نهاية MCP (HTTP قابل للبث). استخدم GET عليها في متصفح للحصول على وصف.",
    discoveryWellKnownMcp: "مستند اكتشاف MCP للوكلاء التي تستكشف نطاقًا ما.",
    discoveryAiPlugin: "بيان الإضافة القديم، للأطر التي ما زالت تبحث عن واحد.",
    discoveryMd: "عرض markdown لأي صفحة في الموقع.",
    discoverySitemap: "كل رابط قابل للفهرسة.",
    catalogHeading: "ما الموجود في الكتالوج",
    catalogIntro:
      "يمكن الوصول إلى كل صفحة أدناه بصيغة HTML، وبصيغة markdown تحت `/md/`، وكمدخل مُهيكَل من `/api/v1/pages`.",
    catalogStyles:
      "**{count}** نمط توثيق، لكل منها أمثلة حقيقية مُولَّدة من تعريف CSL الخاص به",
    catalogTools: "**{count}** أداة متصفح مجانية",
    catalogGuides: "**{count}** دليل تعليمي",
    catalogHowToCite: "**{count}** صفحة كيفية توثيق",
    catalogComparisons: "**{count}** مقارنة بين الأنماط",
    catalogConverters: "**{count}** أداة تحويل",
    catalogFields: "**{count}** مجال أكاديمي",
    catalogStyleLandings: "**{count}** صفحة أنماط رئيسية بقواعد تنسيق كاملة",
    faqHeading: "أسئلة شائعة",
    faqFreeQ: "هل واجهة برمجة CitationEasy مجانية؟ وهل أحتاج إلى مفتاح API؟",
    faqFreeA:
      "إنها مجانية ولا يوجد مفتاح API. كل نقطة نهاية تحت /api/v1 لا تتطلب مصادقة ومفتوحة CORS، فيمكنك استدعاؤها من متصفح أو دفتر ملاحظات أو وكيل من دون تسجيل. لا يوجد حد لمعدل الطلبات نفرضه نحن، لكن عمليات البحث عن المُعرِّفات تُوجَّه عبر وسيط إلى Crossref وOpen Library وPubMed، وهذه الخدمات تطبِّق حدود الاستخدام العادل الخاصة بها — استخدم `inputs` للمعالجة الدفعية بدلًا من إطلاق طلبات متوازية كثيرة.",
    faqLlmQ: "هل تُولَّد المراجع بواسطة نموذج لغوي؟",
    faqLlmA:
      "لا. يعمل التنسيق عبر citeproc-js وفق تعريفات Citation Style Language الرسمية، وهو المحرك نفسه الذي تستخدمه برامج إدارة المراجع. المدخل والنمط نفساهما ينتجان دائمًا السلسلة النصية نفسها. تأتي البيانات الوصفية الببليوغرافية من Crossref (لمُعرِّفات DOI) وOpen Library (لأرقام ISBN) وPubMed (لمُعرِّفات PMID) — لا يختلق CitationEasy أي حقول، فأي شيء مفقود من المصدر يبقى مفقودًا في الناتج بدلًا من تخمينه.",
    faqMcpQ: "كيف أصِل وكيلًا بـ CitationEasy عبر MCP؟",
    faqMcpA:
      "وجِّه أي عميل Model Context Protocol إلى https://www.citationeasy.com/api/mcp باستخدام نقل HTTP القابل للبث. لا حاجة إلى أي بيانات اعتماد. في Claude Code: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`. يوفِّر الخادم أدوات لإنشاء المراجع، والبحث بين الأنماط البالغ عددها {count}، والإرشاد حسب نوع المصدر، والبحث في الموقع، وقراءة أي صفحة بصيغة markdown.",
    faqStylesQ: "ما أنماط التوثيق التي يمكن لواجهة البرمجة إنتاجها؟",
    faqStylesA:
      'كل الأنماط البالغ عددها {count} في مستودع Citation Style Language، بما في ذلك APA 7 وMLA 9 ونظاما Chicago كلاهما وHarvard وVancouver وIEEE وAMA، وآلاف أنماط المجلات الفردية. مرِّر slug النمط في حقل `style`. تُحلَّل الـ slugs السهلة مثل "chicago" و"harvard" إلى نسخة CSL الصحيحة، وتجد /api/v1/styles?q= البقية.',
    faqLlmsTxtQ: "ما هو llms.txt وأين يقع ملف CitationEasy الخاص به؟",
    faqLlmsTxtA:
      "llms.txt فهرس نصي بسيط لموقع، مكتوب للنماذج اللغوية لا للمتصفحات. ملف CitationEasy موجود على /llms.txt؛ والنسخة الشاملة التي تسرد كل صفحة في الموقع موجودة على /llms-full.txt.",
    faqMarkdownQ:
      "هل يمكنني قراءة صفحات CitationEasy بصيغة markdown بدلًا من HTML؟",
    faqMarkdownA:
      "نعم. أضِف البادئة /md/ إلى أي مسار في الموقع — مثل /md/citation-style/apa أو /md/tools/word-counter. تُرجِع الصفحات المعتمدة على البيانات محتواها الكامل، بما في ذلك الأمثلة الحقيقية المنسَّقة المُولَّدة من تعريف CSL الخاص بكل نمط. أما صفحات النص المكتوب يدويًا (الأدلة، الأوراق المرجعية السريعة) فتُرجِع بطاقة ملخَّصة بالإضافة إلى رابط HTML الأساسي، لأن نصها موجود في الصفحة نفسها.",
    faqReuseQ: "هل يمكنني استخدام ناتج CitationEasy في منتجي الخاص؟",
    faqReuseA:
      "نعم. المرجع المنسَّق حقيقة عن مصدر؛ استخدمه بحرية. تأتي تعريفات أنماط CSL نفسها من مشروع Citation Style Language بموجب رخصة CC BY-SA 3.0. نقدِّر الإشارة إلى CitationEasy لكنها ليست إلزامية.",
    missingHeading: "هل ينقصك شيء؟",
    missingBody:
      "إذا كان وكيلك يحتاج إلى نقطة نهاية أو حقل أو صيغة غير موجودة هنا، [أخبِرنا](/contact). أم تفضِّل التصفح يدويًا؟ [ابدأ من مُولِّد المراجع](/).",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "ما نمط التوثيق الذي يجب أن أستخدمه؟ - اختبار الأنماط المجاني",
    metaDescription:
      "أجِب عن بضعة أسئلة سريعة حول مجالك ونوع بحثك وتفضيلاتك لتجد أفضل نمط توثيق لبحثك. APA وMLA وChicago وVancouver وغيرها.",
    ogTitle: "ما نمط التوثيق الذي يجب أن أستخدمه؟",
    ogDescription: "أجرِ اختبارنا المجاني لتجد أفضل نمط توثيق لبحثك.",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "اختبار الأنماط",
    backLink: "→ العودة إلى المُولِّد",
    heading: "ما نمط التوثيق الذي يجب أن أستخدمه؟",
    intro: "أجِب عن بضعة أسئلة سريعة، وسنوصيك بأفضل نمط توثيق لبحثك.",
    progress: "السؤال {current} من {total}",
    qDiscipline: "ما مجال دراستك؟",
    optSocialScience: "علم النفس / العلوم الاجتماعية",
    optHumanities: "الأدب / العلوم الإنسانية",
    optHistory: "التاريخ / تاريخ الفن",
    optMedical: "الطب / التمريض / الصحة",
    optEngineering: "الهندسة / علوم الحاسوب",
    optNaturalScience: "العلوم الطبيعية (الأحياء، الكيمياء)",
    optLaw: "القانون",
    optBusiness: "الأعمال / الاقتصاد",
    qPaperType: "ما نوع البحث الذي تكتبه؟",
    optResearch: "بحث علمي أو أطروحة",
    optReview: "مراجعة أدبيات",
    optReport: "تقرير مخبري أو تقرير تقني",
    optEssay: "مقالة أو واجب دراسي",
    optJournal: "مقالة مُقدَّمة لمجلة علمية",
    qRegion: "أين تقع مؤسستك؟",
    optUs: "الولايات المتحدة",
    optUk: "المملكة المتحدة / أستراليا",
    optCanada: "كندا",
    optEurope: "أوروبا (خارج المملكة المتحدة)",
    optOther: "أخرى",
    qPreference: "هل لديك تفضيل لصيغة التوثيق؟",
    optAuthorDate: "إحالات داخل النص (المؤلف، السنة)",
    optNumeric: "مراجع مرقَّمة [1]",
    optFootnotes: "حواشٍ سفلية",
    optNoPreference: "بلا تفضيل",
    styleVancouver: "Vancouver",
    styleAma: "AMA (الجمعية الطبية الأمريكية)",
    styleIeee: "IEEE",
    styleBluebook: "Bluebook",
    styleCse: "CSE (مجلس محرري العلوم)",
    styleChicagoNotes: "Chicago (الحواشي وقائمة المراجع)",
    styleMla: "MLA (الإصدار التاسع)",
    styleApa: "APA (الإصدار السابع)",
    styleHarvard: "Harvard",
    reasonVancouverMedical:
      "نمط Vancouver هو المعيار في مجلات الطب والعلوم الصحية، ويستخدم مراجع مرقَّمة.",
    reasonAma:
      "يُستخدَم نمط AMA على نطاق واسع في المجلات الطبية ويعتمد على الإحالات المرقَّمة.",
    reasonIeee:
      "نمط IEEE هو نمط التوثيق المعياري في مجالات الهندسة وعلوم الحاسوب وتقنية المعلومات.",
    reasonBluebook:
      "يُعَد Bluebook النمط المرجعي للكتابة القانونية. ونمط Chicago هو أقرب بديل عام له.",
    reasonCse: "نمط CSE هو المعيار في الأحياء والعلوم الطبيعية.",
    reasonChicagoHistory:
      "يُعَد نمط Chicago (الحواشي وقائمة المراجع) المعيار الذهبي في التاريخ وتاريخ الفن، ويستخدم الحواشي السفلية للتوثيق.",
    reasonChicagoHumanities:
      "يناسب نمط Chicago (الحواشي وقائمة المراجع) العلوم الإنسانية جيدًا بفضل اعتماده على الحواشي السفلية.",
    reasonMla: "نمط MLA هو المعيار في الأدب واللغات والعلوم الإنسانية.",
    reasonApaBusiness:
      "يُستخدَم نمط APA على نطاق واسع في مجالات الأعمال والاقتصاد والإدارة.",
    reasonHarvard:
      "توثيق Harvard هو النمط الأكثر شيوعًا في جامعات المملكة المتحدة وأستراليا.",
    reasonChicagoFootnotes:
      "يستخدم نمط Chicago (الحواشي وقائمة المراجع) الحواشي السفلية، وهو مثالي للتوثيق المفصَّل.",
    reasonVancouverNumeric:
      "يستخدم نمط Vancouver إحالات مرقَّمة، مما يبقي نصك نظيفًا وسهل القراءة.",
    reasonApaDefault:
      "نمط APA هو نمط التوثيق الأكثر استخدامًا في العلوم الاجتماعية والتربية والعديد من التخصصات الأخرى.",
    recommendLabel: "نوصي بـ",
    generateButton: "أنشئ مراجع {style}",
    retakeButton: "أعِد الاختبار",
    guidesLink: "تصفَّح أدلة التوثيق لدينا لمزيد من المساعدة ←",
    previousButton: "→ السؤال السابق",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "البحث في CitationEasy",
    metaDescription:
      "ابحث في كل صفحات CitationEasy دفعة واحدة: {count} نمط توثيق، وأكثر من 250 أداة مجانية، وأدلة، وصفحات كيفية التوثيق، ومقارنات الأنماط، وأدوات التحويل، والمسرد.",
    keyword1: "البحث عن أنماط التوثيق",
    keyword2: "العثور على دليل توثيق",
    keyword3: "البحث عن أدوات التوثيق",
    ogDescription:
      "ابحث في كل صفحات الموقع دفعة واحدة — الأنماط والأدوات والأدلة وصفحات كيفية التوثيق والمقارنات وأدوات التحويل ومصطلحات المسرد.",
    ogImageSubtitle:
      "كل نمط توثيق وأداة ودليل وصفحة كيفية توثيق ومقارنة وأداة تحويل ومصطلح مسرد — يُبحث فيها معًا.",
    ogKind: "بحث",
    breadcrumb: "البحث",
    heading: "البحث في CitationEasy",
    intro:
      "كل نمط توثيق وأداة ودليل وصفحة كيفية توثيق ومقارنة وأداة تحويل ومصطلح مسرد في الموقع — يُبحث فيها معًا.",
    inputLabel: "عبارة البحث",
    inputPlaceholder: "مثال: توثيق بودكاست بنمط APA، الإزاحة المعلقة، DOI",
    submit: "بحث",
    browseHeading: "أو تصفَّح حسب القسم",
    browseStyles: "أنماط التوثيق",
    browseStylesNote: "{count} نمط",
    browseTools: "أدوات مجانية",
    browseToolsNote: "{count} أداة",
    browseHowTo: "كيفية توثيق أي مصدر",
    browseHowToNote: "{count} صفحة",
    browseGuides: "الأدلة",
    browseGuidesNote: "{count} دليل",
    browseGlossary: "المسرد",
    browseGlossaryNote: "{count} مصطلح",
    browseComparisons: "مقارنات الأنماط",
    browseComparisonsNote: "{count} مقارنة",
    browseConverters: "أدوات التحويل",
    browseConvertersNote: "{count} أداة تحويل",
    browseCheatSheets: "الأوراق المرجعية السريعة",
    browseCheatSheetsNote: "{count} ورقة",
    facetsLabel: "التصفية حسب نوع الصفحة",
    facetAll: "الكل ({count})",
    noMatches: "لا توجد صفحات مطابقة لـ«{query}».",
    matchesOne: "{count} صفحة مطابقة لـ«{query}».",
    matchesMany: "{count} صفحة مطابقة لـ«{query}».",
    pagerLabel: "صفحات النتائج",
    pagerPrevious: "→ السابق",
    pagerNext: "التالي ←",
    pagerPosition: "الصفحة {page} من {total}",
    paletteLoading: "جارٍ البحث…",
    paletteError: "البحث غير متاح حاليًا. يُرجى المحاولة مرة أخرى.",
    paletteViewAll: "عرض جميع نتائج «{query}»",
    apiNote:
      "تبني شيئًا ما؟ الفهرس نفسه متاح بصيغة JSON على [/api/v1/search](/api/v1/search?q=podcast) وعبر MCP — راجِع [وثائق الوكلاء](/ai).",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "توثيق هذه الصفحة - توثيق بنقرة واحدة (أداة مفضلة وإضافة Chrome)",
    metaDescription:
      'وثِّق أي صفحة ويب بنقرة واحدة. اسحب أداة "توثيق هذه الصفحة" المفضلة المجانية إلى شريط المفضلة لديك، أو ثبِّت إضافة Chrome المجانية التي توفر زر شريط أدوات وتوثيقًا بالنقر بزر الفأرة الأيمن. تعمل أيضًا على أجهزة Chromebook والمتصفحات المقيَّدة.',
    ogTitle: "أداة توثيق هذه الصفحة المفضلة وإضافة Chrome",
    ogDescription:
      "توثيق مواقع بنقرة واحدة من أي صفحة — أداة مفضلة بالسحب والإفلات، بالإضافة إلى إضافة Chrome مجانية بتوثيق عبر النقر بزر الفأرة الأيمن.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "أداة توثيق هذه الصفحة المفضلة",
    appName: "أداة توثيق هذه الصفحة المفضلة",
    appDescription:
      "أداة مفضلة مجانية توثِّق صفحة الويب التي تقرؤها بنقرة واحدة — تفتح CitationEasy مع تعبئة رابط الصفحة مسبقًا، ثم تُنسِّق المرجع بأنماط APA وMLA وChicago و{count} نمط آخر.",
    breadcrumbLabel: "مسار التصفح",
    breadcrumbHome: "الرئيسية",
    breadcrumbCurrent: "أداة توثيق هذه الصفحة المفضلة",
    heading: "توثيق هذه الصفحة: أداة مفضلة وإضافة Chrome",
    intro:
      "وثِّق أي صفحة ويب بنقرة واحدة — بلا تسجيل. اسحب الأداة المفضلة أدناه إلى شريط المفضلة لديك (بلا أي تثبيت على الإطلاق)، أو احصل على إضافة Chrome المجانية للحصول على زر شريط أدوات وتوثيق بالنقر بزر الفأرة الأيمن.",
    dragPrompt: "اسحب هذا الزر إلى شريط المفضلة لديك:",
    buttonTitle: "اسحبني إلى شريط المفضلة لديك",
    buttonLabel: "📑 توثيق هذه الصفحة",
    dontClick: "لا تنقر عليه هنا — اسحبه أولًا إلى شريط المفضلة لديك.",
    installHeading: "كيفية التثبيت",
    step1Title: "أظهِر شريط المفضلة",
    step1Body:
      "في معظم المتصفحات، اضغط Ctrl+Shift+B (أو Cmd+Shift+B على Mac) لإظهار شريط المفضلة حتى يكون لديك مكان لإفلات الزر فيه.",
    step2Title: "اسحب الزر إلى الأعلى",
    step2Body:
      'انقر مع الاستمرار على زر "توثيق هذه الصفحة" أدناه، ثم اسحبه إلى شريط المفضلة لديك وأفلته. سيصبح مفضلة عادية.',
    step3Title: "انقر عليه في أي صفحة",
    step3Body:
      "أثناء قراءة مقالة أو خبر أو صفحة دورية، انقر على مفضلتك الجديدة. يفتح CitationEasy مع تعبئة رابط تلك الصفحة مسبقًا والمرجع جاهزًا للنسخ.",
    manualHeading: "لا يمكنك سحبها؟ أضِفها يدويًا",
    manualBody:
      'أنشئ مفضلة جديدة، سمِّها "توثيق هذه الصفحة"، والصق هذا بوصفه الرابط/العنوان:',
    howHeading: "كيف تعمل",
    howBody:
      "لا تُشغِّل الأداة المفضلة أي كود على الصفحة التي تقرؤها. إنها فقط تُرسِل عنوان تلك الصفحة إلى CitationEasy، حيث يجلب خادمنا البيانات الوصفية العامة للصفحة ويحلِّلها — وهو المسار الموثوق نفسه المستخدَم عند لصق رابط في المُولِّد يدويًا. هذا يجعلها آمنة ويتجنَّب قيود النطاقات المتقاطعة التي أنهت عمل الأدوات المفضلة القديمة داخل الصفحة.",
    extensionHeading: "تفضِّل إضافة Chrome؟",
    extensionBody:
      "تضيف إضافة CitationEasy المجانية زرًا في شريط الأدوات لتوثيق التبويب الحالي، بالإضافة إلى خيارات بالنقر بزر الفأرة الأيمن لتوثيق رابط — أو DOI أو ISBN محدَّد — من دون فتحه. مثل الأداة المفضلة، لا تُشغِّل أي كود على الصفحات التي تزورها: إنها فقط تُرسِل الرابط إلى CitationEasy. تحتاج فقط إلى صلاحيتَي `activeTab` و`contextMenus`، وتعمل في Chrome وEdge وBrave وغيرها من متصفحات Chromium.",
    downloadButton: "⬇ تنزيل إضافة Chrome (.zip)",
    install1: "نزِّل الإضافة وفُك ضغطها.",
    install2: "افتح `chrome://extensions` وفعِّل **وضع المطوِّر** (أعلى اليمين).",
    install3: "انقر **تحميل غير مُعبَّأة** واختر المجلد الذي فككت ضغطه.",
    install4:
      "ثبِّت زر CitationEasy في شريط الأدوات، ثم انقر عليه في أي صفحة لتوثيقها.",
    faqHeading: "أسئلة شائعة",
    faqWhatQ: 'ما هي أداة "توثيق هذه الصفحة" المفضلة؟',
    faqWhatA:
      "هي مفضلة صغيرة تسحبها إلى شريط المفضلة في متصفحك. عند النقر عليها في أي صفحة ويب، تفتح CitationEasy في تبويب جديد مع تعبئة رابط تلك الصفحة مسبقًا، فتحصل على مرجع منسَّق بنقرة واحدة — بلا نسخ ولصق.",
    faqExtensionNeededQ: "هل أحتاج إلى تثبيت إضافة؟",
    faqExtensionNeededA:
      "لا. الأداة المفضلة هي مجرد مفضلة، فلا شيء يُثبَّت ولا صلاحيات تُمنح. تعمل على أجهزة Chromebook المدرسية المقيَّدة وعلى معظم متصفحات الجوال حيث تُحظر الإضافات. إذا كنت تفضِّل إضافة، تتوفر أيضًا إضافة Chrome مجانية في هذه الصفحة.",
    faqChromeQ: "هل توجد إضافة Chrome؟",
    faqChromeA:
      "نعم. تضيف إضافة CitationEasy المجانية لـ Chrome زرًا في شريط الأدوات لتوثيق التبويب الحالي، بالإضافة إلى خيارات بالنقر بزر الفأرة الأيمن لتوثيق رابط أو DOI/ISBN محدَّد من دون فتحه. لا تُشغِّل أي كود على الصفحات التي تزورها وتحتاج فقط إلى صلاحيتَي activeTab وcontextMenus. نزِّلها من هذه الصفحة وحمِّلها عبر chrome://extensions، وتعمل في Chrome وEdge وBrave وغيرها من متصفحات Chromium.",
    faqAddQ: "كيف أضيف الأداة المفضلة؟",
    faqAddA:
      'تأكَّد من أن شريط المفضلة ظاهر، ثم اسحب زر "توثيق هذه الصفحة" في هذه الصفحة إليه. إذا تعذَّر السحب (على الجوال مثلًا)، أنشئ مفضلة جديدة يدويًا والصق كود الأداة المفضلة بوصفه الرابط.',
    faqSafeQ: "هل هي آمنة؟ هل تقرأ الصفحة التي أنا فيها؟",
    faqSafeA:
      "نعم، هي آمنة. لا تُشغِّل الأداة المفضلة أي كود على الصفحة التي تقرؤها — إنها فقط تُرسِل عنوان تلك الصفحة إلى CitationEasy، حيث يجلب خادمنا البيانات الوصفية العامة للصفحة ويحلِّلها، تمامًا كما يفعل عند لصق رابط يدويًا.",
    faqOtherSourcesQ: "هل تعمل مع مصادر غير المواقع الإلكترونية؟",
    faqOtherSourcesA:
      'الأداة المفضلة مخصَّصة لصفحات الويب، لكن الرابط الأساسي يقبل أيضًا DOI أو ISBN أو PMID أو مُعرِّف arXiv عبر معامل ?source= — لذا يعمل رابط "توثيق هذا" القابل للمشاركة مع مقالات الدوريات والكتب أيضًا.',
    relatedHeading: "أدوات ذات صلة",
    relatedGenerator: "مُولِّد المراجع",
    relatedHowToCite: "كيفية توثيق موقع إلكتروني",
    relatedTools: "كل الأدوات",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle: "قائمة مراجع مشتركة - عرض المراجع المشتركة واستيرادها",
    metaDescription:
      "افتح قائمة مراجع شاركها معك أحد من CitationEasy. اعرض المراجع المنسَّقة، وانسخها، أو استورد القائمة كاملةً إلى قائمة مراجعك — مجانًا وبلا حساب، والبيانات محفوظة داخل الرابط نفسه.",
    ogTitle: "قائمة مراجع مشتركة",
    ogDescription:
      "اعرض قائمة مراجع مشتركة واستوردها. تنتقل المراجع داخل الرابط نفسه — لا شيء يُخزَّن على خادم، والروابط لا تنتهي صلاحيتها أبدًا.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "مسار التصفح",
    breadcrumbHome: "الرئيسية",
    breadcrumbCurrent: "قائمة مراجع مشتركة",
    heading: "قائمة مراجع مشتركة",
    intro:
      "شارك أحدهم هذه المراجع معك. انسخها، أو استورد القائمة كاملةً إلى قائمة مراجعك في CitationEasy بنقرة واحدة.",
    loading: "جارٍ فتح قائمة المراجع المشتركة…",
    copyAll: "نسخ الكل",
    copied: "تم النسخ",
    copyFailed: "فشل النسخ",
    citationOne: "مرجع",
    citationMany: "مراجع",
    addAll: "إضافة الكل إلى قائمة مراجعي",
    added: "أُضيف {count} إلى قائمة مراجعك",
    skippedOne: "تم تخطي {count} مكرر",
    skippedMany: "تم تخطي {count} مكررات",
    openGenerator: "افتح المُولِّد",
    emptyHeading: "لا توجد قائمة مراجع مشتركة في هذا الرابط",
    emptyBody:
      "تعرض هذه الصفحة قوائم المراجع المشتركة من CitationEasy. لمشاركة قائمتك، افتحها في [مُولِّد المراجع](/)، واختر **تصدير ← نسخ رابط المشاركة**، ثم أرسِل الرابط لأي شخص. تنتقل المراجع داخل الرابط نفسه — لا شيء يُخزَّن على خادم، لذا تظل الروابط تعمل إلى الأبد وتبقى بياناتك خاصة.",
    decodeError: "تعذَّر فتح رابط المشاركة هذا.",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "كتاب",
    bookLower: "كتاب",
    bookChapter: "فصل من كتاب",
    bookChapterLower: "فصل من كتاب",
    case: "قضية",
    caseLower: "قضية",
    conferencePaper: "ورقة مؤتمر",
    conferencePaperLower: "ورقة مؤتمر",
    courtCase: "قضية محكمة",
    courtCaseLower: "قضية محكمة",
    federalStatute: "قانون اتحادي",
    federalStatuteLower: "قانون اتحادي",
    governmentDocument: "وثيقة حكومية",
    governmentDocumentLower: "وثيقة حكومية",
    governmentReport: "تقرير حكومي",
    governmentReportLower: "تقرير حكومي",
    journalArticle: "مقالة دورية",
    journalArticleLower: "مقالة دورية",
    lawReviewArticle: "مقالة في مجلة قانونية",
    lawReviewArticleLower: "مقالة في مجلة قانونية",
    legislation: "تشريع",
    legislationLower: "تشريع",
    newspaperArticle: "مقالة صحفية",
    newspaperArticleLower: "مقالة صحفية",
    patent: "براءة اختراع",
    patentLower: "براءة اختراع",
    podcast: "بودكاست",
    podcastLower: "بودكاست",
    preprint: "نسخة أولية",
    preprintLower: "نسخة أولية",
    standard: "معيار",
    standardLower: "معيار",
    thesis: "أطروحة",
    thesisLower: "أطروحة",
    website: "موقع إلكتروني",
    websiteLower: "موقع إلكتروني",
    youtubeVideo: "فيديو يوتيوب",
    youtubeVideoLower: "فيديو يوتيوب",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "العودة إلى {style}",
    backToGenerator: "العودة إلى مُولِّد المراجع",
    ctaHeading: "أنشئ مراجع {style} تلقائيًا",
    ctaButton: "وثِّق بنمط {style} الآن ←",
    faqHeading: "أسئلة شائعة",
    resourcesHeading: "مزيد من المصادر",
    relatedHeading: "أدلة {style} ذات صلة",
    resourceGenerator: "مُولِّد مراجع مجاني ({count} نمط)",
    resourceTools: "أدوات الكتابة المجانية",
    resourceGuides: "كل أدلة التوثيق",
    resourceStyleGenerator: "مُولِّد مراجع {style}",
    resourceExamples: "أمثلة على مراجع {style}",
    resourceFormat: "دليل تنسيق {style}",
    resourceInText: "دليل الإحالة داخل النص بنمط {style}",
    resourceAnnotatedBib: "دليل قائمة المراجع المشروحة بنمط {style}",
    resourceReferencePage: "دليل {list} بنمط {style}",
    notFoundTitle: "غير موجود",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "أمثلة على مراجع {style} - كل أنواع المصادر [2026]",
    metaDescription:
      "طالِع أمثلة مُنسَّقة على مراجع {style} ({edition}) للكتب ومقالات الدوريات والمواقع الإلكترونية وغيرها. مدخلات {list} وإحالات داخل النص جاهزة للنسخ.",
    ogTitle: "أمثلة على مراجع {style}",
    ogDescription: "مدخلات {style} جاهزة للنسخ لكل نوع مصدر شائع.",
    ogImageTitle: "أمثلة على مراجع {style}",
    ogKind: "{style} {edition}",
    keywordExamples: "أمثلة على مراجع {style}",
    keywordReference: "أمثلة مراجع {style}",
    keywordInText: "أمثلة الإحالة داخل النص بنمط {style}",
    keywordList: "أمثلة {listLower} بنمط {style}",
    keywordHowTo: "كيفية التوثيق بنمط {style}",
    breadcrumb: "أمثلة على مراجع {style}",
    heading: "أمثلة على مراجع {style}",
    lead: "طالِع أمثلة مُنسَّقة بشكل صحيح على مراجع {style} ({edition}) لـ{count} نوع من أنواع المصادر الشائعة. يتضمَّن كل مثال مدخل {listLower} والإحالة داخل النص المطابقة له.",
    entryLabel: "مدخل {list}:",
    inTextLabel: "الإحالة داخل النص:",
    ctaBody:
      "تجاوَز التنسيق اليدوي. الصق مُعرِّف DOI أو رابطًا أو رقم ISBN في CitationEasy، واحصل على مرجع {style} منسَّق تنسيقًا كاملًا في ثوانٍ.",
    faqLookQ: "كيف يبدو مرجع {style}؟",
    faqLookA:
      "يتضمَّن مرجع {style} مدخل {listLower} يحتوي على تفاصيل المصدر كاملةً، وإحالة داخل النص. يختلف التنسيق حسب نوع المصدر. على سبيل المثال، يتضمَّن مرجع كتاب بنمط {style} ({edition}) المؤلف والسنة والعنوان والناشر.",
    faqHowManyQ: "كم عدد أمثلة مراجع {style} المتاحة؟",
    faqHowManyA:
      "يوفِّر CitationEasy أمثلة على مراجع {style} لـ{count} نوع مصدر، منها {types}. يتضمَّن كل مثال مدخل {listLower} والإحالة داخل النص المطابقة له.",
    faqCopyQ: "هل يمكنني نسخ أمثلة مراجع {style} هذه؟",
    faqCopyA:
      "نعم، تعرض أمثلة {style} في هذه الصفحة التنسيق الدقيق لكل نوع مصدر. يمكنك استخدامها كقوالب لمراجعك الخاصة. للحصول على تنسيق تلقائي، استخدم مُولِّد مراجع {style} المجاني لدينا.",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle: "دليل تنسيق {style} - قواعد تنسيق الأبحاث [2026]",
    metaDescription:
      "دليل شامل لتنسيق أبحاث {style} ({edition}). تعرَّف على الخط وهوامش الصفحة والتباعد وصفحة العنوان والترويسات وقواعد تنسيق {listLower} الصحيحة.",
    ogTitle: "تنسيق بحث {style}",
    ogDescription:
      "هوامش الصفحة والخط والتباعد وصفحة العنوان لبحث بنمط {style}.",
    ogImageTitle: "تنسيق بحث {style}",
    ogImageSubtitle: "هوامش {margins} · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "تنسيق {style}",
    keywordPaperFormat: "تنسيق بحث {style}",
    keywordRules: "قواعد تنسيق {style}",
    keywordMargins: "هوامش وخط وتباعد {style}",
    keywordList: "تنسيق {listLower} بنمط {style}",
    breadcrumb: "دليل تنسيق {style}",
    heading: "دليل تنسيق {style}",
    lead: "اتبع قواعد تنسيق أبحاث {style} ({edition}) هذه للتأكد من أن مستندك يستوفي المعايير المطلوبة. يغطي هذا الدليل الخط وهوامش الصفحة والتباعد وصفحة العنوان والترويسات وتنسيق {listLower}.",
    paperHeading: "تنسيق البحث",
    paperIntro:
      "فيما يلي متطلبات التنسيق الأساسية للأبحاث المكتوبة بنمط {style} ({edition}).",
    labelFont: "الخط",
    labelFontSize: "حجم الخط",
    labelMargins: "هوامش الصفحة",
    labelSpacing: "التباعد",
    labelTitlePage: "صفحة العنوان",
    labelHeaders: "الترويسات / أرقام الصفحات",
    listHeading: "تنسيق {list}",
    listIntro:
      "يجب أن يتبع {listLower} لديك هذه القواعد ليكون منسَّقًا بشكل صحيح بنمط {style}:",
    ctaBody:
      "دَع CitationEasy يتولى التنسيق. الصق مُعرِّف DOI أو رابطًا أو رقم ISBN، واحصل على مرجع {style} منسَّق تنسيقًا كاملًا في ثوانٍ.",
    faqFontQ: "ما الخط والحجم اللذان يجب استخدامهما لتنسيق {style}؟",
    faqFontA:
      "يتطلب {style} ({edition}) استخدام {font}. حجم الخط المعياري هو {fontSize}.",
    faqMarginsQ: "ما متطلبات هوامش الصفحة في {style}؟",
    faqMarginsA:
      "تتطلب أبحاث {style} هوامش {margins}. ينطبق هذا على الهوامش العلوية والسفلية واليمنى واليسرى في كل صفحة.",
    faqTitlePageQ: "هل يتطلب {style} صفحة عنوان؟",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle: "دليل الإحالة داخل النص بنمط {style} - القواعد والأمثلة [2026]",
    metaDescription:
      "تعرَّف على كيفية تنسيق الإحالات داخل النص بنمط {style} ({edition}). قواعد المؤلف الواحد، والمؤلفين المتعددين، والاقتباس المباشر، وحالة عدم وجود مؤلف أو تاريخ، مع أمثلة.",
    ogTitle: "الإحالات داخل النص بنمط {style}",
    ogDescription: "كل صيغ الإحالة داخل النص بنمط {style}، مع أمثلة.",
    ogImageTitle: "الإحالات داخل النص بنمط {style}",
    ogImageSubtitle:
      "مؤلف واحد {singleAuthor} · ثلاثة مؤلفين أو أكثر {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "الإحالة داخل النص بنمط {style}",
    keywordExamples: "أمثلة الإحالة داخل النص بنمط {style}",
    keywordParenthetical: "الإحالة بين قوسين بنمط {style}",
    keywordRules: "قواعد التوثيق بنمط {style}",
    keywordHowTo: "كيفية الإحالة داخل النص بنمط {style}",
    breadcrumb: "الإحالات داخل النص بنمط {style}",
    heading: "الإحالات داخل النص بنمط {style}",
    lead: "أتقِن الإحالات داخل النص بنمط {style} ({edition}) من خلال هذا الدليل الكامل. تعرَّف على التنسيق الصحيح لكل حالة، بما في ذلك المؤلف الواحد والمؤلفين المتعددين، والاقتباس المباشر، والمصادر التي تنقصها معلومات.",
    rulesHeading: "قواعد الإحالة داخل النص",
    rulesIntro:
      "فيما يلي قواعد الإحالة داخل النص بنمط {style} لكل حالة شائعة ستواجهها عند كتابة بحثك.",
    labelSingleAuthor: "مؤلف واحد",
    labelTwoAuthors: "مؤلفان اثنان",
    labelThreeOrMore: "ثلاثة مؤلفين أو أكثر",
    labelDirectQuote: "اقتباس مباشر",
    labelNoAuthor: "بلا مؤلف",
    labelNoDate: "بلا تاريخ",
    examplesHeading: "أمثلة سريعة",
    examplesIntro:
      "إليك أمثلة واقعية على الإحالة داخل النص بنمط {style} لأنواع مختلفة من المصادر:",
    ctaBody:
      "توقَّف عن القلق بشأن تنسيق الإحالة داخل النص. الصق مُعرِّف DOI أو رابطًا أو رقم ISBN في CitationEasy، واحصل فورًا على مدخل {listLower} والإحالة داخل النص معًا.",
    faqFormatQ: "كيف أنسِّق إحالة داخل النص بنمط {style}؟",
    faqFormatA:
      "لمؤلف واحد في {style}، استخدم الصيغة {singleAuthor}. لمؤلفين اثنين، استخدم {twoAuthors}. لثلاثة مؤلفين أو أكثر، استخدم {threeOrMore}.",
    faqQuoteQ: "كيف أوثِّق اقتباسًا مباشرًا بنمط {style}؟",
    faqQuoteA:
      "للاقتباسات المباشرة بنمط {style} ({edition})، استخدم الصيغة: {directQuote}.",
    faqMissingQ: "ماذا لو لم يكن هناك مؤلف أو تاريخ في {style}؟",
    faqMissingA:
      "عند عدم وجود مؤلف في {style}، استخدم: {noAuthor}. وعند عدم وجود تاريخ، استخدم: {noDate}.",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "دليل {list} بنمط {style} - قواعد التنسيق [2026]",
    metaDescription:
      "تعرَّف على كيفية تنسيق {listLower} بنمط {style} ({edition}). قواعد تنسيق خطوة بخطوة وأمثلة وأخطاء شائعة يجب تجنُّبها في {fullName}.",
    ogTitle: "{listLower} بنمط {style}",
    ogDescription: "كيفية إعداد {list} بنمط {style}.",
    ogImageTitle: "{list} بنمط {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "كيفية تنسيق {list} بنمط {style}",
    heading: "كيفية تنسيق {list} بنمط {style}",
    lead: "يُعَد {listLower} أحد أهم أجزاء أي بحث أكاديمي منسَّق بنمط {style} ({edition}). فهو يزوِّد القراء بالتفاصيل الكاملة لكل مصدر استشهدت به، مما يتيح لهم تحديد مراجعك والتحقق منها. الحصول على التنسيق الصحيح أمر أساسي للمصداقية الأكاديمية. يغطي هذا الدليل القواعد الدقيقة، ويعرض أمثلة حقيقية، ويسلِّط الضوء على أكثر الأخطاء شيوعًا بين الطلاب.",
    rulesHeading: "قواعد التنسيق",
    rulesIntro: "اتبع هذه القواعد عند إعداد {listLower} بنمط {style}:",
    exampleHeading: "مثال على {list}",
    exampleIntro:
      "إليك كيف يبدو {listLower} بنمط {style} بمدخلات لأنواع مختلفة من المصادر:",
    mistakesHeading: "أخطاء شائعة يجب تجنُّبها",
    mistakesIntro:
      "هذه هي أكثر خمسة أخطاء تنسيق شيوعًا يرتكبها الطلاب عند إعداد {listLower} بنمط {style}:",
    mistakeIndent:
      "**غياب الإزاحة المعلقة أو استخدامها بشكل غير صحيح:** يجب أن يبدأ السطر الأول من كل مدخل من الهامش، وأن تُزاح جميع الأسطر التالية بمقدار 0.5 بوصة. استخدم إعدادات الفقرة في برنامج معالجة النصوص بدلًا من الضغط على مفتاح Tab.",
    mistakeOrder:
      '**ترتيب أبجدي أو تسلسل غير صحيح:** يجب ترتيب المدخلات وفق قواعد {style}. تجاهَل أدوات التعريف مثل "A" و"An" و"The" عند الترتيب الأبجدي. أما في الأنماط الرقمية، فرتِّب المدخلات حسب ترتيب ظهورها الأول في النص.',
    mistakeSpacing:
      "**تباعد غير متسق:** تحقَّق من تباعد الأسطر في {listLower} بأكمله. الخلط بين التباعد الفردي والمزدوج خطأ شائع يسهل إغفاله.",
    mistakeItalics:
      "**استخدام خاطئ للخط المائل:** استخدم الخط المائل لعناوين الأعمال المستقلة مثل الكتب والدوريات، لكن لا تستخدمه لعناوين المقالات أو الفصول. راجِع إرشادات {style} لمعرفة العناصر التي يجب أن تكون مائلة بالضبط.",
    mistakeLinks:
      "**مُعرِّفات DOI وروابط مفقودة أو معطوبة:** أدرِج دائمًا مُعرِّف DOI عند توفُّره، بصيغة رابط قابل للنقر. اختبر كل رابط قبل تسليم بحثك للتأكد من أنه يوصِل إلى المصدر الصحيح.",
    ctaHeading: "أنشئ {list} تلقائيًا",
    ctaBody:
      "تجاوَز التنسيق اليدوي. الصق مُعرِّف DOI أو رابطًا أو رقم ISBN في CitationEasy، واحصل على مرجع {style} منسَّق تنسيقًا كاملًا في ثوانٍ، جاهز لإدراجه في {listLower}.",
    faqWhatQ: "ما هو {list} بنمط {style}؟",
    faqWhatA:
      "{list} بنمط {style} هو القسم الموجود في نهاية بحثك ويسرد جميع المصادر التي استشهدت بها في نصك، منسَّقًا وفق إرشادات {fullName} ({edition}). يتيح للقراء تحديد كل مصدر أشرت إليه والتحقق منه.",
    faqFormatQ: "كيف أنسِّق {listLower} بنمط {style}؟",
    faqFormatA:
      'ابدأ في صفحة جديدة، وضَع لها عنوان "{list}"، وأدرِج كل المصادر التي استشهدت بها في بحثك. اتبع قواعد {style} المحددة للإزاحة المعلقة والتباعد والترتيب الأبجدي أو الرقمي والخط المائل.',
    faqDifferenceQ: "ما الفرق بين {listLower} وقائمة المراجع؟",
    faqDifferenceA:
      'يتضمَّن {listLower} فقط المصادر التي استشهدت بها مباشرةً في بحثك، بينما قد تتضمَّن قائمة المراجع أيضًا مصادر رجعت إليها لكن لم تستشهد بها. في {style} ({edition})، تُسمَّى القائمة الموجودة في نهاية البحث "{list}".',
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "دليل قائمة المراجع المشروحة وأمثلة لنمط {style} [2026]",
    metaDescription:
      "تعرَّف على كيفية كتابة قائمة مراجع مشروحة بنمط {style} ({edition}). يتضمَّن قواعد التنسيق ونماذج مدخلات ونصائح لقوائم {fullName} المشروحة.",
    ogTitle: "قائمة مراجع مشروحة بنمط {style}",
    ogDescription: "كيفية تنسيق قائمة مراجع مشروحة بنمط {style}.",
    ogImageTitle: "قائمة مراجع مشروحة بنمط {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "قائمة مراجع مشروحة بنمط {style}",
    heading: "قائمة مراجع مشروحة بنمط {style}",
    lead: "قائمة المراجع المشروحة هي قائمة من مراجع المصادر، يتضمَّن كل مرجع منها فقرة قصيرة وصفية أو تقييمية. في تنسيق {style} ({edition})، يبدأ كل مدخل بمرجع منسَّق تنسيقًا صحيحًا يليه شرح يلخِّص المصدر أو يقيِّمه أو يتأمَّل فيه. يرشدك هذا الدليل إلى القواعد والتنسيق والأمثلة اللازمة لإعداد قائمة مراجع مشروحة متقنة بنمط {style}.",
    whatHeading: "ما هي قائمة المراجع المشروحة؟",
    whatBody:
      "تتجاوز قائمة المراجع المشروحة {listLower} العادية بإضافة فقرة قصيرة بعد كل مرجع. يمنح هذا الشرح القراء نظرة على محتوى المصدر وجودته وصلته بالموضوع. كثيرًا ما يكلِّف المدرِّسون الطلاب بإعداد قوائم مراجع مشروحة لمساعدتهم على تقييم مصادرهم تقييمًا نقديًا وإظهار كيف يسهم كل مصدر في موضوع بحثهم.",
    whatTypes:
      "توجد ثلاثة أنواع شائعة من الشروح: شروح **وصفية** تلخِّص المصدر، وشروح **تقييمية** تقيِّم جودة العمل وموثوقيته، وشروح **مزدوجة** تجمع بين الاثنين. ينبغي أن تحدِّد تعليمات الواجب أيَّ نوع يجب استخدامه.",
    rulesHeading: "قواعد قائمة المراجع المشروحة بنمط {style}",
    rulesIntro:
      "اتبع هذه القواعد عند تنسيق قائمة مراجع مشروحة بنمط {fullName}:",
    exampleHeading: "مثال على مدخل في قائمة مراجع مشروحة",
    exampleIntro:
      "فيما يلي نموذج مدخل في قائمة مراجع مشروحة بنمط {style} لمصدر من نوع {sourceType}:",
    exampleAnnotation:
      "يقدِّم هذا المصدر نظرة شاملة على الموضوع، ويطرح حججًا مدعومة جيدًا بأدلة تجريبية. يستند المؤلف إلى مجموعة واسعة من المصادر الأولية والثانوية لبناء طرح مقنع. المنهجية دقيقة والنتائج معروضة بوضوح، ما يجعل هذا العمل مصدرًا قيِّمًا لفهم الموضوع. يفيد هذا المصدر بشكل خاص في إرساء الإطار النظري لمشروع البحث، ويقدِّم منظورات تكمِّل الأعمال الأخرى في قائمة المراجع.",
    tipsHeading: "نصائح لكتابة شروح {style}",
    tipSummarize:
      "ابدأ بتلخيص المصدر في جملتين أو ثلاث جمل، ثم أضِف تقييمك لنقاط قوته وحدوده ومدى صلته بالموضوع.",
    tipTone:
      "استخدم صيغة الغائب وأسلوبًا أكاديميًا في كل شروحك. تجنَّب اللغة العامية أو التأملات بصيغة المتكلم ما لم يطلب مدرِّسك ذلك.",
    tipLength:
      "اجعل كل شرح بين 100 و200 كلمة. كن موجزًا وركِّز على أهم جوانب المصدر.",
    tipRelevance:
      "اشرح كيف يتناسب المصدر مع بحثك بوجه عام. صِف المنظور أو الدليل الفريد الذي يسهم به.",
    tipCitation:
      "تأكَّد من أن جزء المرجع في كل مدخل يتبع قواعد تنسيق {fullName} تمامًا قبل كتابة الشرح.",
    ctaHeading: "أنشئ قائمة مراجعك المشروحة تلقائيًا",
    ctaBody:
      "استخدم أداة CitationEasy لإنشاء قوائم المراجع المشروحة لتوليد مراجع {style} منسَّقة تنسيقًا صحيحًا، ثم أضِف شروحك.",
    ctaButton: "افتح أداة إنشاء قائمة المراجع المشروحة ←",
    faqWhatQ: "ما هي قائمة المراجع المشروحة بنمط {style}؟",
    faqWhatA:
      "قائمة المراجع المشروحة بنمط {style} ({edition}) هي قائمة مراجع منسَّقة بنمط {fullName}، يلي كل منها فقرة قصيرة تلخِّص المصدر أو تقيِّمه أو تتأمَّل فيه. تساعد القارئ على فهم صلة كل مصدر بالموضوع وجودته.",
    faqLengthQ: "ما الطول المناسب للشرح؟",
    faqLengthA:
      "عادةً ما يتراوح طول الشرح بين 100 و200 كلمة. قد تتطلب بعض الواجبات شروحًا أقصر أو أطول حسب عمق التحليل المطلوب. تحقَّق دائمًا من إرشادات مدرِّسك لمعرفة متطلبات الطول المحددة.",
    faqIncludeQ: "ماذا ينبغي أن يتضمَّن الشرح؟",
    faqIncludeA:
      "ينبغي أن يتضمَّن الشرح ملخصًا موجزًا لحجة المصدر الرئيسية أو نتائجه، وتقييمًا لموثوقية المصدر وفائدته، وتأملًا في كيفية تناسبه مع بحثك. بعض الشروح وصفية بحتة، بينما تتضمَّن أخرى تحليلًا نقديًا.",
  },

  guidePage: {
    byline: "إعداد {author}",
    published: "نُشر في {date}",
    updated: "حُدّث في {date}",
    readingTime:
      "zero:أقل من دقيقة للقراءة|one:دقيقة واحدة للقراءة|two:دقيقتان للقراءة|few:{count} دقائق للقراءة|many:{count} دقيقة للقراءة|other:{count} دقيقة للقراءة",
    wordCount:
      "zero:لا كلمات|one:كلمة واحدة|two:كلمتان|few:{count} كلمات|many:{count} كلمة|other:{count} كلمة",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "مكتبة الأدلة",
    browseByCategory: "التصفح حسب الفئة",
    recentlyUpdated: "حُدِّثت مؤخرًا",
    allGuides: "جميع الأدلة",
    guideCount:
      "zero:لا أدلة|one:دليل واحد|two:دليلان|few:{count} أدلة|many:{count} دليلًا|other:{count} دليل",
    updatedOn: "حُدِّث في {date}",
    minRead:
      "zero:أقل من دقيقة للقراءة|one:دقيقة واحدة للقراءة|two:دقيقتان للقراءة|few:{count} دقائق للقراءة|many:{count} دقيقة للقراءة|other:{count} دقيقة للقراءة",
    onThisPage: "في هذه الصفحة",
    viewAllInCategory: "جميع أدلة {category}",
    moreInCategory: "المزيد في {category}",
    aboutThisGuide: "حول هذا الدليل",
    provenance: "كتبه {author}. نُشر في {published}؛ آخر تحديث في {updated}.",
    categoryIntroSuffix:
      "كل دليل مجاني، ومكتوب للطلاب والباحثين، ومؤرَّخ حتى تعرف متى جرت مراجعته آخر مرة.",
    photoCredit: "الصورة: {author}، {source} ({license})",
    imageAlt: "صورة توضح أدلة {category}",
    imageSourceCommons: "ويكيميديا كومنز",
    apaStyleName: "نمط APA",
    apaStyleDescription:
      "كيفية توثيق المواقع الإلكترونية ومقالات الدوريات والكتب ومقاطع الفيديو وغيرها وفق الإصدار السابع من APA، مع أمثلة لقائمة المراجع والاستشهاد داخل النص.",
    mlaStyleName: "نمط MLA",
    mlaStyleDescription:
      "كيفية توثيق كل المصادر الشائعة وفق الإصدار التاسع من MLA، من صفحات الويب والمقالات إلى القصائد والمسرحيات والأفلام ومواد المقررات.",
    chicagoStyleName: "نمط شيكاغو",
    chicagoStyleDescription:
      "أدلة دليل شيكاغو للأسلوب تغطي توثيق الحواشي-الببليوغرافيا والمؤلف-التاريخ للكتب والمقالات والأرشيفات والوثائق الحكومية والوسائط.",
    styleComparisonsName: "مقارنات الأنماط",
    styleComparisonsDescription:
      "مقارنات جنبًا إلى جنب بين APA وMLA وشيكاغو وهارفارد وفانكوفر وIEEE وغيرها، مع نصائح حول النمط الذي يتوقعه تخصصك.",
    researchMethodsName: "مناهج البحث",
    researchMethodsDescription:
      "كيفية التخطيط لورقة بحثية، ومراجعة الأدبيات، وتدوين الملاحظات، وتقييم المصادر، وتجنب الانتحال، وإعداد قائمة المراجع.",
    academicWritingName: "الكتابة الأكاديمية",
    academicWritingDescription:
      "أدلة لكتابة الملخصات والمقدمات والخاتمات وعبارات الأطروحة وأقسام المنهجية ونثر أكاديمي واضح.",
    fieldSpecificName: "حسب التخصص",
    fieldSpecificDescription:
      "أدلة توثيق لكل تخصص على حدة، من علم النفس والتاريخ والأدب إلى الطب والهندسة والقانون والتمريض.",
    sourceEvaluationName: "تقييم المصادر",
    sourceEvaluationDescription:
      "كيفية الحكم على المصداقية، والتمييز بين المصادر العلمية والشائعة، واستخدام الباحث العلمي من Google وقواعد بيانات المكتبات، ورصد التحيز.",
    citationHelpName: "مساعدة في التوثيق",
    citationHelpDescription:
      "إجابات عن الحالات الصعبة: غياب المؤلف أو التاريخ، وتعدد المؤلفين، وملفات PDF، وأدوات الذكاء الاصطناعي، والقضايا القانونية، واستيراد الاستشهادات أو تصديرها.",
  },

  common: {
    backToGuides: "العودة إلى الأدلة →",
    free: "مجاني",
    noSignup: "لا حاجة للتسجيل",
    backToHome: "العودة إلى مُولِّد المراجع",
    inEnglish: "بالإنجليزية",
    viewInEnglish: "اعرضها بالإنجليزية",
    availableInEnglish: "تتوفر هذه الصفحة بالإنجليزية بتفصيل أوسع.",
    otherLanguages: "لغات أخرى",
    skipToContent: "تخطَّ إلى المحتوى",
    cookieNotice:
      "نستخدم ملفات تعريف الارتباط للتحليلات والإعلانات لإبقاء CitationEasy مجانيًا.",
    privacyPolicy: "سياسة الخصوصية",
    accept: "موافقة",
    decline: "رفض",
    advertisement: "إعلان",
  },
  legalPage: {
    backLink: "→ العودة إلى المُولِّد",
    effective: "تاريخ السريان:",
    updated: "آخر تحديث:",
  },
};

export default ar;
